import React from 'react';
import * as d3Module from 'd3';
import d3Tip from 'd3-tip';
import $ from "jquery";
import {event as currentEvent} from 'd3-selection';
const d3 = {
  ...d3Module,
  tip: d3Tip
};

  const environment_icon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g id="icon_server" transform="translate(-1385 -1420)"><path id="icon_server-2" data-name="icon_server" d="M19.875,8.5H4.125A1.125,1.125,0,0,1,3,7.375V5.125A1.125,1.125,0,0,1,4.125,4h15.75A1.125,1.125,0,0,1,21,5.125v2.25A1.125,1.125,0,0,1,19.875,8.5ZM18.188,5.406a.844.844,0,1,0,.844.844A.844.844,0,0,0,18.188,5.406Zm-2.25,0a.844.844,0,1,0,.844.844A.844.844,0,0,0,15.938,5.406Zm3.938,8.719H4.125A1.125,1.125,0,0,1,3,13V10.75A1.125,1.125,0,0,1,4.125,9.625h15.75A1.125,1.125,0,0,1,21,10.75V13A1.125,1.125,0,0,1,19.875,14.125Zm-1.687-3.094a.844.844,0,1,0,.844.844A.844.844,0,0,0,18.188,11.031Zm-2.25,0a.844.844,0,1,0,.844.844A.844.844,0,0,0,15.938,11.031Zm3.938,8.719H4.125A1.125,1.125,0,0,1,3,18.625v-2.25A1.125,1.125,0,0,1,4.125,15.25h15.75A1.125,1.125,0,0,1,21,16.375v2.25A1.125,1.125,0,0,1,19.875,19.75Zm-1.687-3.094a.844.844,0,1,0,.844.844A.844.844,0,0,0,18.188,16.656Zm-2.25,0a.844.844,0,1,0,.844.844A.844.844,0,0,0,15.938,16.656Z" transform="translate(1385 1420)"/><rect id="Rectangle_626" data-name="Rectangle 626" width="24" height="24" transform="translate(1385 1420)" fill="none"/></g></svg>'
  const datasource_icon = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="database" class="svg-inline--fa fa-database fa-w-14 form-control__icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"></path></svg>'
  const dataset_icon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g id="icon_layers" transform="translate(-1449 -1420)"><path id="icon_layer-group" d="M4.412,8.915l7.734,3.509a.85.85,0,0,0,.707,0l7.734-3.509a.742.742,0,0,0,0-1.329L12.854,4.077a.85.85,0,0,0-.707,0L4.412,7.585A.742.742,0,0,0,4.412,8.915Zm16.176,2.931-1.929-.874L13.292,13.4a1.915,1.915,0,0,1-1.585,0L6.341,10.972l-1.929.874a.741.741,0,0,0,0,1.328l7.734,3.506a.852.852,0,0,0,.707,0l7.735-3.506A.741.741,0,0,0,20.588,11.846Zm0,4.243-1.921-.871-5.374,2.436a1.914,1.914,0,0,1-1.585,0L6.334,15.218l-1.922.871a.741.741,0,0,0,0,1.328l7.734,3.506a.852.852,0,0,0,.707,0l7.735-3.506A.741.741,0,0,0,20.588,16.089Z" transform="translate(1449 1420)"/><rect id="Rectangle_628" data-name="Rectangle 628" width="24" height="24" transform="translate(1449 1420)" fill="none"/></g></svg>'
  // const attribute_icon = '<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="tag" class="svg-inline--fa fa-tag fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"></path></svg>'
  // const environment_sunbrust_color = ["#3EA8A6","#5D94CB","#E47961","#3FB1D5","#3C7B90","#FB9F2B","#4CA3FF","#915EF9","#4ED2CC","#959595","#396DA8","#AF5095"]
  // const datasource_sunbrust_color  = ["#3FB1D5","#3C7B90","#FB9F2B","#4CA3FF","#915EF9","#4ED2CC","#959595","#396DA8","#AF5095","#3EA8A6","#5D94CB","#E47961"]
  // const datset_sunbrust_color      = ["#4CA3FF","#915EF9","#4ED2CC","#959595","#396DA8","#AF5095","#3EA8A6","#5D94CB","#E47961","#3FB1D5","#3C7B90","#FB9F2B"]

  const environment_sunbrust_color = [ "#F79AA4", "#8AC3FF", "#CB8DBA", "#82CCE3", "#80A9B6", "#FCC075", "#95B9DD", "#B796FB", "#8BE1DE",  "#BABABA", "#7EA0C6", "#EDA798", "#71C5BD" ]
  const datasource_sunbrust_color  = [ "#95B9DD", "#B796FB", "#F68B96", "#82CCE3", "#80A9B6", "#FCC075", "#8AC3FF", "#71C5BD", "#8BE1DE",  "#BABABA", "#7EA0C6", "#CB8DBA", "#EDA798" ]
  const datset_sunbrust_color      = [ "#95B9DD", "#80A9B6", "#EDA798", "#82CCE3", "#71C5BD", "#FCC075", "#8AC3FF", "#B796FB", "#8BE1DE",  "#BABABA", "#7EA0C6", "#CB8DBA", "#F68B96" ]
  const attribute_sunbrust_color   = [ "#CB8DBA", "#F68B96", "#80A9B6", "#82CCE3", "#EDA798", "#FCC075", "#8AC3FF", "#B796FB", "#8BE1DE",  "#BABABA", "#7EA0C6", "#71C5BD", "#95B9DD" ]
  
  const custom_dq_heat_map_colors = [
  {"color":"#18A1CD","value":-100},
  {"color":"#24A0C2","value":-90},
  {"color":"#309FB8","value":-80},
  {"color":"#3C9EAD","value":-60},
  {"color":"#489CA1","value":-50},
  {"color":"#549C97","value":-40},
  {"color":"#609A8B","value":-30},
  {"color":"#6C9981","value":-20},
  {"color":"#789877","value":-10},
  {"color":"#83976C","value":0},
  {"color":"#8F9661","value":10},
  {"color":"#9A9456","value":20},
  {"color":"#A7934B","value":30},
  {"color":"#B29240","value":40},
  {"color":"#BF9135","value":50},
  {"color":"#CA902B","value":60},
  {"color":"#D78F1F","value":70},
  {"color":"#E28E15","value":80},
  {"color":"#EF8E0B","value":90},
  {"color":"#FA8C00","value":100},
];

function getToolTipDatasourceContent(d,i,chatdatatooltip){
  let chatdata = chatdatatooltip;

  let atotalcnt = chatdata.data_issue_integration_grouped_bar_chart.filter(laur => {
      return String(d.month) === String(getDateFormat(laur.month)) 
    });

    let countjson = atotalcnt[0]['issues'][d.column.split("##")[0]];
    let cnt = parseInt(countjson["New_issue"])+parseInt(countjson["Old_issue"])+parseInt(countjson["Solved_issue"])
    let env_id = countjson.env_id
    let env_name = getmappingvalue("environments",env_id,chatdata);
  let issuename = (d.name.replace(d.column.split("##")[1]+"_", "")).replace("_"," ")+'s';
  let content = "<div class='d3-tip__header'>" +  d.column.split("##")[1] + "</div>";
  content += `
      <div class='d3-tip__body'>
          <div class='d3-tip__section'>
              <p><label>Environment: </label>`+env_name+`</p>
              <p><label>Datasource: </label>`+d.column.split("##")[1]+`</p>
              <p><label>Total Number of Data Quality Issues: </label>`+cnt+`</p>
              <p><label>Number of `+issuename+`: </label>${d.yEnd-d.yBegin}</p>
              <p><label>Period: </label>`+d.month+`</p>
              </div>
      </div>`;
  return content;
  
}
function getToolTipContent(d,i,chatdatatooltip) {
  let chatdata = chatdatatooltip;
  let issuename = (d.name.replace(d.column+"_", "")).replace("_"," ")+'s';
  let content = "<div class='d3-tip__header'>" +  d.column + "</div>";

  let atotalcnt = chatdata.data_issue_grouped_bar_chart.filter(laur => {
    return String(d.month) === String(getDateFormat(laur.month)) 
  });
  let countjson = atotalcnt[0]['issues'][d.column.split("##")[0]];
  let cnt = parseInt(countjson["New_issue"])+parseInt(countjson["Old_issue"])+parseInt(countjson["Solved_issue"])

  content += `
      <div class='d3-tip__body'>
          <div class='d3-tip__section'>
              <p><label>Environment: </label>`+d.column.split("##")[1]+`</p>
              <p><label>Total Number of Data Quality Issues: </label>${cnt}</p>
              <p><label>Number of `+issuename+`: </label>${d.yEnd-d.yBegin}</p>
              <p><label>Period: </label>`+d.month+`</p>
              </div>
      </div>`;
  return content;
}


function getToolTipContentPackedChart(d,i,chartdata){
  // if(d.depth === 0){
  //   return;
  // }

let header = '';
if(d.data.env_id!==undefined){
  header+= `<p><label>Environment:</label>`+getmappingvalue("environments",d.data.env_id,chartdata)+`</p>`;
}
if(d.data.integration_id!==undefined){
  header+= `<p><label>Datasource:</label>`+getmappingvalue("integrations",d.data.integration_id,chartdata)+`</p>`;
}
if(d.data.data_set_id!==undefined){
  header+= `<p><label>Dataset:</label>`+getmappingvalue("datasets",d.data.data_set_id,chartdata)+`</p>`;
}
if(d.data.meta_data_id!==undefined){
  header+= `<p><label>Attribute:</label>`+d.data.name+`</p>`;
}
let totaltipattr="";
let childer_1 = '';
let childer_2 = '';
let childer_3 = '';
let childer_4 = '';
let childer='';
for (var key in d.data.tooltip) {
  if(!key.includes("Total")){
    if(d.depth === 4){
      totaltipattr+= `<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<label>Total No. of `+key+` issues:</label>`+d.data.tooltip[key]+`</p>`;
    }else { 
      totaltipattr+= `<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<label>Total No. of `+key+`:</label>`+d.data.tooltip[key]+`</p>`;
    }
  }else{
    let replaceval = key.replace("Total", "Total No. of ");
    if(key==="Total data quality issues"){
      if(d.depth === 4){
        childer+= `<p><label>`+replaceval+`:</label>`+d.data.tooltip[key]+`</p>`;
      }else { 
        childer+= `<p><label>`+replaceval+` at attribute level :</label>`+d.data.tooltip[key]+`</p>`;
      }  
    }else{
      // datasources
      if(key.includes("datasources")){
        replaceval = key.replace("Total datasources having", "Total No. of datasources having attributes with");
        childer_2= `<p><label>`+replaceval+`:</label>`+d.data.tooltip[key]+`</p>`;
      }
      if(key.includes("datasets")){
        replaceval = key.replace("Total datasets having", "Total No. of datasets having attributes with");
        childer_3= `<p><label>`+replaceval+`:</label>`+d.data.tooltip[key]+`</p>`;
      }
      if(key.includes("attributes")){
        childer_4= `<p><label>`+replaceval+`:</label>`+d.data.tooltip[key]+`</p>`;
      }
      // if(d.depth === 4){
      //   childer_1+= `<p><label>`+replaceval+`:</label>`+d.data.tooltip[key]+`</p>`;
      // } 
    }  
  }
}
let tooltiphtml = d.depth === 4 ?  header+childer+totaltipattr : header+totaltipattr+childer+childer_1+childer_2+childer_3+childer_1+childer_4; 
let content = "<div class='d3-tip__header'>" +  d.data.name + "</div>";
//let content = "<div class='d3-tip__header'>Data quality issue</div>";
  content += `
      <div class='d3-tip__body'>
          <div class='d3-tip__section'>
              `+tooltiphtml+
          `</div>
      </div>`;
  return content;
}

function getToolTipContentSunBrustInner(d,i,type){
  let content = "<div class='d3-tip__header'>"+d.parent.data.name+"</div>";
 //let content = "<div class='d3-tip__header'>Data quality issue</div>";

 content += `
 <div class='d3-tip__body'>
     <div class='d3-tip__section'>`;

 if(type==="env"){
  content += `<p><label>Environment: </label>`+d.data.envnametooltip+`</p>`;
}
if(type==="datasource"){
  content += `<p><label>Environment: </label>`+d.data.envnametooltip+`</p>`;
  content += `<p><label>Datasource: </label>`+d.data.datasourcenametooltip+`</p>`;
}  
if(type==="dataset"){
  content += `<p><label>Environment: </label>`+d.data.envnametooltip+`</p>`;
  content += `<p><label>Datasource: </label>`+d.data.datasourcenametooltip+`</p>`;
  content += `<p><label>Dataset: </label>`+d.data.datasetnametooltip+`</p>`;
}  
if(type==="attribute"){
  content += `<p><label>Environment: </label>`+d.data.envnametooltip+`</p>`;
  content += `<p><label>Datasource: </label>`+d.data.datasourcenametooltip+`</p>`;
  content += `<p><label>Dataset: </label>`+d.data.datasetnametooltip+`</p>`;
  content += `<p><label>Attribute: </label>`+d.parent.data.name+`</p>`;
}  
//content += `<p><label>Total Number of Data Quality Issues: </label>`+d.data.count+`</p>`;
content += `<p><label>Number of `+d.data.name+` issues: </label>`+d.data.count+` (`+d.data.percentage.toFixed(0)+`%)</p>`;
          content += `</div>
      </div>`;
  return content;
}
function getToolTipContentSunBrust(d,i,type) {
  let content = "<div class='d3-tip__header'>"+d.data.name+"</div>";
  //let content = "<div class='d3-tip__header'>Data quality issue</div>";
  content += `
      <div class='d3-tip__body'>
          <div class='d3-tip__section'>`
              if(type==="env"){
                content += `<p><label>Environment: </label>`+d.data.name+`</p>`;
              }
              if(type==="datasource"){
                content += `<p><label>Environment: </label>`+d.data.envnametooltip+`</p>`;
                content += `<p><label>Datasource: </label>`+d.data.datasourcenametooltip+`</p>`;
              }  
              if(type==="dataset"){
                content += `<p><label>Environment: </label>`+d.data.envnametooltip+`</p>`;
                content += `<p><label>Datasource: </label>`+d.data.datasourcenametooltip+`</p>`;
                content += `<p><label>Dataset: </label>`+d.data.datasetnametooltip+`</p>`;
              }  

              if(type==="attribute"){
                content += `<p><label>Environment: </label>`+d.data.envnametooltip+`</p>`;
                content += `<p><label>Datasource: </label>`+d.data.datasourcenametooltip+`</p>`;
                content += `<p><label>Dataset: </label>`+d.data.datasetnametooltip+`</p>`;
              }  
              content += `<p><label>Total Number of Data Quality Issues: </label>`+d.data.percentage+`</p>`;
                let children = d.data.children;
                for(let loop=0;loop<children.length;loop++){
                  content += `<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<label>Number of `+children[loop]["name"]+` Issues : </label> `+children[loop]["count"]+`(`+children[loop]["percentage"].toFixed(0)+`%)</p>`;
                }
          content += `</div>
      </div>`;
  return content;
}
export function label_cutstring(pmlabel,pmcustring){
  return String(pmlabel).substring(0, pmcustring)+'...'
}

export function getDateFormat(pmDate) {
  const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  let date = new Date(pmDate);
  return month[date.getMonth()]+" "+date.getFullYear();
}

export function getHeatMapColorCode(pmValue) {
  var myColor = d3.scaleLinear()
      .range(['#F68B96','#FFFFFF','#6A91BE'])
      .domain([-100,0,100]);
      return myColor(pmValue > 100 ? 100 :pmValue);
}

export function getmappingvalue(pmtype,pmvalue,data){
  let dq_reports_data = data;
  let filterData;
  switch(pmtype) {
      case "environments":
          filterData = dq_reports_data.id_name_mapping.environments;
          break;
      case "datasets":
          filterData = dq_reports_data.id_name_mapping.datasets;
          break;
          case "integrations":
          filterData = dq_reports_data.id_name_mapping.integrations;
          break; 
      case "metrics":
          filterData = dq_reports_data.id_name_mapping.metrics;
          break; 
      case "metadata":
          filterData = dq_reports_data.id_name_mapping.metadata;
          break;
      case "mas":
            filterData = dq_reports_data.id_name_mapping.mas;
            break;   
      default:
            filterData = dq_reports_data.id_name_mapping.mas;
            break;           
    }
    
    for(let key in filterData){
      if(parseInt(key) === parseInt(pmvalue)){
        // if(filterData[key] === "Production"){
        //   return "TMS";
        // }
        // else if(filterData[key] === "Patch"){
        //   return "SAP Finance";
        // }
        // else if(filterData[key] === "Staging"){
        //   return "WMS";
        // }
        // else if(filterData[key] === "Transport data"){
        //   return "Customer1_TMS";
        // }
        // else if(filterData[key] === "Income data"){
        //   return "Customer2_TMS";
        // }
        // else if(filterData[key] === "Health Data"){
        //   return "Customer3_TMS";
        // }
        // else if(filterData[key] === "Tourism data"){
        //   return "Customer1_WMS";
        // }
        // else if(filterData[key] === "Student"){
        //   return "Customer2_WMS";
        // }
        // else if(filterData[key] === "Sample data"){
        //   return "Customer3_WMS";
        // }
        // else if(filterData[key] === "Accessories data"){
        //   return "Customer1_SAP Finance";
        // }
        // else if(filterData[key] === "Sales data"){
        //   return "Customer2_SAP Finance";
        // }
        // else if(filterData[key] === "Business data"){
        //   return "Customer3_SAP Finance";
        // }
        // else if(filterData[key] === "Market data"){
        //   return "Customer4_SAP Finance";
        // }
        // else if(filterData[key] === "Commerce data"){
        //   return "Customer5_SAP Finance";
        // }
      return filterData[key];
      }
  }
}

class dqReports extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
      }
  }

  newIssueDatasourceChart() {
    $("#"+this.props.chartid).html("");
    let yBegin;
    let innerColumnsList = {};
    let innerColumnsListData = [];
    let obj = this.props.chartdata.data_issue_integration_grouped_bar_chart;
    if(obj.length===0){
      $("#datasourcenewissue").hide()
      $("#datasourcenewissuelegend").hide()
    }else {
      $("#datasourcenewissue").show()
      $("#datasourcenewissuelegend").show()
    }
    let totalbar = 0;
    for(let loop=0;loop<obj.length;loop++){
        let newobj = {};
        newobj.MONTH_YEAR = getDateFormat(obj[loop]["month"]);
        let datacheck = 0;
        for (var key in obj[loop]["issues"]){
          for (let key1 in obj[loop]["issues"][key]){
            if(key1!=="env_id"){
              let value = obj[loop]["issues"][key][key1];
                 if(value > 0 ){
                  datacheck = 1;
                 }
                 newobj[getmappingvalue("integrations",key,this.props.chartdata)+'_'+key1] = value;
          } 
          }   
          if(datacheck === 1){
              innerColumnsList[key+"##"+getmappingvalue("integrations",key,this.props.chartdata)]   = [getmappingvalue("integrations",key,this.props.chartdata)+"name",getmappingvalue("integrations",key,this.props.chartdata)+"_New_issue",getmappingvalue("integrations",key,this.props.chartdata)+"_Old_issue",getmappingvalue("integrations",key,this.props.chartdata)+"_Solved_issue"]
              totalbar++;
            }
          }
        innerColumnsListData.push(newobj)
    }
    let data = innerColumnsListData;
    let innerColumns  = innerColumnsList;
    var margin = {top: 20, right: 200, bottom: 75, left: 150},
          width = 960 - margin.left - margin.right,
          height = totalbar*40 - margin.top - margin.bottom;
       
          if(height < 100){
            height = 100;
          }
        
    
      var x0 = d3.scaleBand().range([0, height]).paddingInner(0.10);
      var x1 = d3.scaleBand().padding(0.09);
      var y = d3.scaleLinear()
          .range([0, width]);
      var xAxis = d3.axisLeft()
          .scale(x0);
    
      var yAxis = d3.axisBottom()
          .scale(y)
          .tickSizeInner(-height)
          .tickSizeOuter(0)
          .tickPadding(10)
          .tickFormat(d3.format(".2s"));
       
          var color = d3.scaleOrdinal().range(
            ["#F68B96","#6A91BE","#6FC4DF"]);
          var svg = d3.select("#"+this.props.chartid).append("svg")
           .attr("viewBox", [0, 0, width + margin.left + margin.right, height + margin.top + margin.bottom])
           .attr("font-family", "Poppins")
           .style("width", "100%")
           .attr("width", width + margin.left + margin.right)
           .attr("height", height + margin.top + margin.bottom)
           .append("g")
           .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
    var columnHeaders = d3.keys(data[0]).filter(function(key) { return key !== "MONTH_YEAR"; });
        color.domain(d3.keys(data[0]).filter(function(key) { return key !== "MONTH_YEAR"; }));
        data.forEach(function(d) {
          let env_id;
          let totalissue =0;
          for (var key in d) {
            if (d.hasOwnProperty(key)) {
              if(key.includes("New_issue") || key.includes("Solved_issue") || key.includes("Old_issue") ){
//                totalissue += parseInt(d[key])
          // let arkey = key.split("_");
          // if(data[0].columnDetails !== undefined){
          //  atotalcnt = data[0].columnDetails.filter(laur => {
          //   return String(laur.column.split("##")[1]) === String(arkey[0]) 
          // });
          // }
          // //console.log(data[0].columnDetails);
          // if(atotalcnt!==undefined){
          //   totalissue = 0;
          //   for(let loop=0;loop<atotalcnt.length;loop++){
          //     totalissue += atotalcnt[loop]['yEnd'] 
          //   }
          // }
          // console.log(atotalcnt);
          // console.log("###")
        }
       }
    }

          let yColumn = [];
          let xColumn = [];
          let index = 0;
          // let envid;
          d.columnDetails = columnHeaders.map(function(name) {
            for (let ic in innerColumns) {
              if($.inArray(name, innerColumns[ic]) >= 0){
                if (!yColumn[ic]){
                  yColumn[ic] = 0;
                  // envid = innerColumns;
                  index = 0;
                }
                yBegin = yColumn[ic];
                yColumn[ic] += +d[name];
                xColumn[ic] += +d[name];
                // let yend = d[name] + yBegin;
                // yend = yend === 0 ? 50 : yend;  
                return {name: name, column: ic, yBegin: yBegin, yEnd: +d[name] + yBegin,index:index++,totalissue:totalissue,month:d.MONTH_YEAR,env_id:env_id};
              }
            }
            return true;
          });
          d.total = d3.max(d.columnDetails, function(d) { 
            return d.yEnd; 
          });
        });
      
        x0.domain(data.map(function(d) { return d.MONTH_YEAR; }));
        x1.domain(d3.keys(innerColumns)).range([0, x0.bandwidth()]);
        y.domain([0, d3.max(data, function(d) { 
          return d.total; 
        })]);
    
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0,0)")
            .call(xAxis);
       
        svg.append("g")
            .attr("class", "y axis")
            // .attr("class", function(d,i) { console.log(d);alert(i); return "y axis";})
            .attr("transform", "translate(0,"+height+")")
            .call(yAxis)
          .append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 0)
            .attr("x", 0)
            .attr("dx", ".7em")
            .style("text-anchor", "end");

            let chatdatatooltip = this.props.chartdata;

            let tip = d3.tip()
    .attr('class', 'd3-tip')
    .direction('e')
    .offset([0,5])
    .html(function(d,i) {
        return getToolTipDatasourceContent(d,i,chatdatatooltip);
    });
    svg.call(tip);

        var project_stackedbar = svg.selectAll(".project_stackedbar")
            .data(data)
          .enter().append("g")
          .attr("transform", function(d) { return "translate(0," + x0(d.MONTH_YEAR) +")"; });
    
        project_stackedbar.selectAll("rect")
            .data(function(d) { return d.columnDetails; })
            .enter().append("g").attr("class", "groupclass")
            // .attr('stroke', '#E1E1E1')
            // .attr('stroke-width', '1') 
            .append("rect")
            //.attr("height", x1.bandwidth())
            .attr("height", '20px')
            .attr("class", "groupinnerclass ")
            .attr("y", function(d) { 
              return x1(d.column);
            })
            .attr("x", function(d) {
                return y(d.yBegin)+1;
              // return y(d.yEnd) - y(d.yBegin); 
            })
            .attr("width", function(d) { 
              return   y(d.yEnd) - y(d.yBegin); 
            })
            .style("fill", function(d) {
                 return color(d.index);
            })
            .attr('stroke', '#fff')
            .attr("stroke-width", function(d,i) {
              if(i%3 === 0){
                return 0;
              }else {
                return 1;
              }
            })
            .on('mouseover', tip.show)
            .on('mouseout', tip.hide)
    
          svg.selectAll(".groupclass")
          .insert("path","rect")
         .attr("stroke", "grey")
         .attr("stroke-width", "1")
         .attr("stroke-dasharray", "5,2")
         .attr("stroke-opacity", "0.2")
         .attr("d", function(d) { 
          return "M5 "+(x1(d.column)+10)+" l"+(width+5)+" 0";
        })
    
        svg.selectAll(".groupclass")
        .append("text")
        .attr("class", "dq-report-gbar-right-label")
        .attr("text-anchor", "start")
        .attr("height", x1.bandwidth())
       .attr("y", function(d) {
         return x1(d.column)+15; })
       .attr("x", width+14)
       .attr("fill","currentColor")
       .text(function(d){
         if(d.index===0){
           return d.column.split("##")[1];
         }
       });
    
    
      // text label for the x axis
      svg.append("text")             
      .attr("transform",
            "translate(" + (width/2) + " ," + 
                           (height + margin.top + 50) + ")")
      .style("text-anchor", "middle")
      .attr("class", "dq-report-graph-title")
      .text("Number of Data Quality Issues - by Datasource");
    
    // text label for the y axis
    svg.append("text")
      .attr("transform", "rotate(-90)")
      .attr("y", 0 - margin.left)
      .attr("x",0 - (height / 2))
      .attr("dy", "1em")
      .attr("class", "dq-report-graph-title")
      .style("text-anchor", "middle")
      .text("Month");      
  }

 

  renderTop5DataQualityChart() {
    let chartid = this.props.chartid;
    let artid = this.props.art;
    let labelsid = this.props.labels;
    let chartdata = this.props.chartdata;
    let data = chartdata.top_5_data_quality_issues_types;

    if (data.length === 0) {
        $("#widget6").hide();
    } else {
        $("#widget6").show();
    }

    let cDim = {
        height: 720,
        width: 820,
        innerRadius: 118,
        outerRadius: 100,
        labelRadius: 205
    };

    let svg = d3.select('#top5_data_quality')
    .attr("height", cDim.height)
    .attr("width", cDim.width);

if (svg) {
    let canvas = d3.select('#' + chartid),
        art = d3.select('#' + artid),
        labels = d3.select('#' + labelsid);

    // Calculate the center of the SVG canvas
    let centerX = cDim.width / 2;
    let centerY = cDim.height / 2;

    // Center the canvas using transform
    canvas.attr('transform', `translate(${centerX}, ${centerY})`);

    let d3Pie = d3.pie().value(d => d.count);
    let pieData = d3Pie(data);
    let pieArc = d3.arc()
        .innerRadius(cDim.innerRadius)
        .outerRadius(cDim.outerRadius);

    let colors = ["#79BAFF", "#6A91BE", "#AC86FA", "#7ADDD9", "#F68B96"];

    // Draw the wedges
    let enteringArcs = art.selectAll('.wedge')
        .data(pieData)
        .enter();

    enteringArcs.append('path')
        .attr('class', 'wedge')
        .attr('d', pieArc)
        .style('fill', (d, i) => colors[i]);

    // Central text
    canvas.append('text')
        .attr('class', 'toolCircle')
        .attr('dy', -15)
        .html('Top 5')
        .style('font-size', '24px')
        .style('font-weight', '600')
        .style('color', '#4B4B4B')
        .style('text-anchor', 'middle');

    canvas.append('text')
        .attr('class', 'toolCircle')
        .attr('dy', 15)
        .html('Data quality issues')
        .style('font-size', '18px')
        .style('color', '#4B4B4B')
        .style('text-anchor', 'middle');

    // Add labels with lines
    let enteringLabels = labels.selectAll('.label')
        .data(pieData)
        .enter();

    let labelGroups = enteringLabels.append('g')
        .attr('class', 'label');

    let lines = labelGroups.append('line')
        .attr("x1", d => pieArc.centroid(d)[0])
        .attr("y1", d => pieArc.centroid(d)[1])
        .attr("x2", d => {
            let centroid = pieArc.centroid(d),
                midAngle = Math.atan2(centroid[1], centroid[0]);
            return Math.cos(midAngle) * cDim.labelRadius;
        })
        .attr("y2", d => {
            let centroid = pieArc.centroid(d),
                midAngle = Math.atan2(centroid[1], centroid[0]);
            return Math.sin(midAngle) * cDim.labelRadius;
        })
        .attr('class', 'label-line')
        .attr('stroke', (d, i) => colors[i]);

        let textLabels = labelGroups.append('text')
        .attr("x", function(d) {
            let centroid = pieArc.centroid(d),
                midAngle = Math.atan2(centroid[1], centroid[0]),
                x = Math.cos(midAngle) * cDim.labelRadius,
                sign = x > 0 ? 1 : -1;
            return x + (5 * sign);
        })
        .attr("y", function(d) {
            let centroid = pieArc.centroid(d),
                midAngle = Math.atan2(centroid[1], centroid[0]),
                y = Math.sin(midAngle) * cDim.labelRadius;
            return y;
        })
        .attr("text-anchor", function(d) {
            let centroid = pieArc.centroid(d),
                midAngle = Math.atan2(centroid[1], centroid[0]),
                x = Math.cos(midAngle) * cDim.labelRadius;
            return x > 0 ? 'start' : 'end';
        })
        .attr('class', 'label-text')
        .style("font-size", "14px")
        .style("font-weight", "600")
        .style("color", "#4B4B4B")
        .html(function(d) {
            return getmappingvalue("mas", d.data.mas_id, chartdata) + ' <br/>( ' + d.data.count + ' ) ';
        });
    
    // Improve label alignment
    const forceCollide = d3.forceCollide(20); // Adjust the radius as needed

    d3.forceSimulation(pieData)
        .force('y', d3.forceY(d => Math.sin(Math.atan2(pieArc.centroid(d)[1], pieArc.centroid(d)[0])) * cDim.labelRadius).strength(0.7))
        .force('collide', forceCollide)
        .on('tick', () => {
            textLabels
                .attr('x', d => {
                    let midAngle = Math.atan2(pieArc.centroid(d)[1], pieArc.centroid(d)[0]),
                        x = Math.cos(midAngle) * cDim.labelRadius,
                        sign = x > 0 ? 1 : -1;
                    return x + (5 * sign);
                })
                .attr('y', d => d.y)
                .attr('text-anchor', d => Math.cos(Math.atan2(pieArc.centroid(d)[1], pieArc.centroid(d)[0])) > 0 ? 'start' : 'end');
    
            lines
                .attr("x2", d => Math.cos(Math.atan2(pieArc.centroid(d)[1], pieArc.centroid(d)[0])) * cDim.labelRadius)
                .attr("y2", d => d.y);
        });
    
}
}


environmentssunbrustchart(){
let vcolorindex;
let chart_env_data = this.props.chartdata.env_sunburst_chart;
let envissue = [];
let envmetricissue = [];
let chart_env_data_filter ;
let chatdata = this.props.chartdata;
let data = this.props.chartdata;

if(chart_env_data.length === 0){
  
}

if(chart_env_data.length===0){
  $("#widget2").hide()
}else {
  $("#widget2").show()
}

$.each(chart_env_data, function(i, item) {
    let envid = item.env_id; 
    vcolorindex = envissue.indexOf(envid);
    if(vcolorindex < 0){
        let obj = {}
       // parrentindex = i;
        obj.name = getmappingvalue("environments",envid,chatdata);
        obj.envid = envid;
        obj.envnametooltip = getmappingvalue("environments",envid,data);
        envissue.push(envid)
        chart_env_data_filter = chart_env_data.filter(function(item,i){
           if(item.env_id === envid){
              chart_env_data[i]["name"] = getmappingvalue("metrics",item.metrics_id,chatdata);
              chart_env_data[i]["size"] = item.count;
              chart_env_data[i]["parent_index"] = envid;
              let innertotalsum = 0;
              for(let cnt=0;cnt<chart_env_data.length;cnt++){
                  if(chart_env_data[cnt].env_id === envid){
                    innertotalsum = parseInt(innertotalsum) + parseInt(item.count);
                  }
                }
              chart_env_data[i]["envnametooltip"] = getmappingvalue("environments",item.env_id,data);
              chart_env_data[i]["innertotalsum"] = innertotalsum;
            }
            return item.env_id === envid;         
        });
    let totalsum = 0;
    for(let cnt=0;cnt<chart_env_data_filter.length;cnt++){
            totalsum = parseInt(totalsum) + parseInt(chart_env_data_filter[cnt]['size']);
    }
    obj.percentage = totalsum;
    obj.parent_index = envid;
    obj.children = chart_env_data_filter;
    envmetricissue.push(obj);
    }
    })
  let sunbustenvvdata = {}
  sunbustenvvdata.name = "";
  sunbustenvvdata.children = envmetricissue;
  this.sunbrustchart(sunbustenvvdata,"env")
}


datasourcesunbrustchart(){
  let vcolorindex;
  let chart_env_data = this.props.chartdata.integration_sunburst_chart;
  let integrationissue = [];
  let integrationmetricissue = [];
  let chart_env_data_filter ;
  let chatdata = this.props.chartdata;
  let data = this.props.chartdata;

  if(chart_env_data.length === 0){
    $("#widget3").hide()
  }else {
        $("#widget3").show()

  }

  $.each(chart_env_data, function(i, item) {
      let integration_id = item.integration_id; 
      vcolorindex = integrationissue.indexOf(integration_id);
      if(vcolorindex < 0){
          let obj = {}
          obj.name = getmappingvalue("integrations",integration_id,chatdata);
          obj.integration_id = integration_id;
          obj.envnametooltip = getmappingvalue("environments",item.env_id,data);
          obj.datasourcenametooltip = getmappingvalue("integrations",item.integration_id,data);
          integrationissue.push(integration_id)
          chart_env_data_filter = chart_env_data.filter(function(item,i){
            if(item.integration_id === integration_id){
              chart_env_data[i]["name"] = getmappingvalue("metrics",item.metrics_id,chatdata);
              chart_env_data[i]["size"] = item.count;
              let innertotalsum = 0;
              for(let cnt=0;cnt<chart_env_data.length;cnt++){
                  if(chart_env_data[cnt].integration_id === integration_id){
                    innertotalsum = parseInt(innertotalsum) + parseInt(item.count);
                  }
                }
              chart_env_data[i]["envnametooltip"] = getmappingvalue("environments",item.env_id,data);
              chart_env_data[i]["datasourcenametooltip"] = getmappingvalue("integrations",item.integration_id,data);
              chart_env_data[i]["innertotalsum"] = innertotalsum;
              chart_env_data[i]["integration_id"] = integration_id;
              }  
              return item.integration_id === integration_id;         
          });
      let totalsum = 0;
      for(let cnt=0;cnt<chart_env_data_filter.length;cnt++){
              totalsum = parseInt(totalsum) + parseInt(chart_env_data_filter[cnt]['size']);
      }
      obj.percentage = totalsum;
      obj.children = chart_env_data_filter;
      integrationmetricissue.push(obj);
      }
      })
    let sunbustintegrationdata = {}
    sunbustintegrationdata.name = "";
    sunbustintegrationdata.children = integrationmetricissue;
    this.sunbrustchart(sunbustintegrationdata,"datasource")
  }

datasetsunbrustchart(){
    let vcolorindex;
    let chart_env_data = this.props.chartdata.data_set_sunburst_chart;
    let datasetissue = [];
    let datasetmetricissue = [];
    let chart_env_data_filter ;
    let chatdata = this.props.chartdata;
    let data = this.props.chartdata;

    if(chart_env_data.length === 0){
      $("#widget4").hide()
    }else {
      $("#widget4").show()
    }
    $.each(chart_env_data, function(indx, item) {
        let data_set_id = item.data_set_id; 
        vcolorindex = datasetissue.indexOf(data_set_id);
        if(vcolorindex < 0){
            let obj = {}
            obj.name = getmappingvalue("datasets",data_set_id,chatdata);
            obj.data_set_id = data_set_id;
            obj.datasetnametooltip = getmappingvalue("datasets",item.data_set_id,data)
            obj.envnametooltip = getmappingvalue("environments",item.env_id,data);
            obj.datasourcenametooltip = getmappingvalue("integrations",item.integration_id,data);
            datasetissue.push(data_set_id)
            chart_env_data_filter = chart_env_data.filter(function(item,i){
              if(item.data_set_id === data_set_id){
              let innertotalsum = 0;
              for(let cnt=0;cnt<chart_env_data.length;cnt++){
                  if(chart_env_data[cnt].data_set_id === data_set_id){
                    innertotalsum = parseInt(innertotalsum) + parseInt(item.count);
                  }
                }

                chart_env_data[i]["name"] = getmappingvalue("metrics",item.metrics_id,chatdata);
                chart_env_data[i]["size"] = item.count;
                chart_env_data[i]["data_set_id"] = data_set_id;
                chart_env_data[i]["datasetnametooltip"] = getmappingvalue("datasets",item.data_set_id,data)
                chart_env_data[i]["envnametooltip"] = getmappingvalue("environments",item.env_id,data);
                chart_env_data[i]["datasourcenametooltip"] = getmappingvalue("integrations",item.integration_id,data);
                chart_env_data[i]["innertotalsum"] = innertotalsum;
              }
            return item.data_set_id === data_set_id;         
            });
        let totalsum = 0;
        for(let cnt=0;cnt<chart_env_data_filter.length;cnt++){
                totalsum = parseInt(totalsum) + parseInt(chart_env_data_filter[cnt]['size']);
        }
        obj.percentage = totalsum;
        obj.children = chart_env_data_filter;
        datasetmetricissue.push(obj);
        }
        })
      let sunbustintegrationdata = {}
      sunbustintegrationdata.name = "";
      sunbustintegrationdata.children = datasetmetricissue;
      this.sunbrustchart(sunbustintegrationdata,"dataset")
}
attributesunbrustchart(){
  let vcolorindex;
  let chart_env_data = this.props.chartdata.attribute_sunburst_chart;
  let attributeissue = [];
  let attributemetricissue = [];
  let chart_env_data_filter ;
  let chatdata = this.props.chartdata;
  let data = this.props.chartdata;
  if(chart_env_data.length === 0){
    $("#widget5").hide()
  }else {
    $("#widget5").show()
  }
  $.each(chart_env_data, function(indx, item) {
      let meta_data_id = item.meta_data_id; 
      vcolorindex = attributeissue.indexOf(meta_data_id);
      if(vcolorindex < 0){
          let obj = {}
          obj.name = getmappingvalue("metadata",meta_data_id,chatdata);
          obj.meta_data_id = meta_data_id;
          obj.datasetnametooltip = getmappingvalue("datasets",item.data_set_id,data)
          obj.envnametooltip = getmappingvalue("environments",item.env_id,data);
          obj.datasourcenametooltip = getmappingvalue("integrations",item.integration_id,data);
          attributeissue.push(meta_data_id)
          chart_env_data_filter = chart_env_data.filter(function(item,i){
            if(item.meta_data_id === meta_data_id){
            let innertotalsum = 0;
            for(let cnt=0;cnt<chart_env_data.length;cnt++){
                if(chart_env_data[cnt].meta_data_id === meta_data_id){
                  innertotalsum = parseInt(innertotalsum) + parseInt(item.count);
                }
              }

              chart_env_data[i]["name"] = getmappingvalue("metrics",item.metrics_id,chatdata);
              chart_env_data[i]["size"] = item.count;
              chart_env_data[i]["meta_data_id"] = meta_data_id;
              chart_env_data[i]["datasetnametooltip"] = getmappingvalue("datasets",item.data_set_id,data)
              chart_env_data[i]["envnametooltip"] = getmappingvalue("environments",item.env_id,data);
              chart_env_data[i]["datasourcenametooltip"] = getmappingvalue("integrations",item.integration_id,data);
              chart_env_data[i]["innertotalsum"] = innertotalsum;
            }
          return item.meta_data_id === meta_data_id;         
          });
      let totalsum = 0;
      for(let cnt=0;cnt<chart_env_data_filter.length;cnt++){
              totalsum = parseInt(totalsum) + parseInt(chart_env_data_filter[cnt]['size']);
      }
      obj.percentage = totalsum;
      obj.children = chart_env_data_filter;
      attributemetricissue.push(obj);
      }
      })
    let sunbustintegrationdata = {}
    sunbustintegrationdata.name = "";
    sunbustintegrationdata.children = attributemetricissue;
    this.sunbrustchart(sunbustintegrationdata,"attribute")
}

packedChart(){
   let pmId = this.props.chartid;
   let hexcolor = "#0099cc";
   let multicolor = true;
   $("#"+pmId).html("")
   let chatdata = this.props.chartdata;
   let root = this.props.chartdata.attribute_packed_chart;
   if(root.children.length===0 || root.children.length===undefined){
    $("#widget8").hide()
   }else {
    $("#widget8").show()
   }
   let env_ids = [];
   if(root.children!==undefined){
    for(let loop=0;loop<root.children.length;loop++){
      env_ids.push(root.children[loop]["env_id"])
    }
   }
 

   // Function to recursively extract unique counts
function extractUniqueCounts(data, uniqueCounts = { env_ids: new Set(), data_set_ids: new Set(), integration_ids: new Set(), meta_data_ids: new Set() }) {
  if (data.env_id) uniqueCounts.env_ids.add(data.env_id);
  if (data.data_set_id) uniqueCounts.data_set_ids.add(data.data_set_id);
  if (data.integration_id) uniqueCounts.integration_ids.add(data.integration_id);
  if (data.meta_data_id) uniqueCounts.meta_data_ids.add(data.meta_data_id);
  
  if (data.children) {
      data.children.forEach(child => extractUniqueCounts(child, uniqueCounts));
  }
  
  return uniqueCounts;
}

// Extract unique counts
const uniqueCounts = extractUniqueCounts(chatdata.attribute_packed_chart);
$("#packed_attr_count").html("&nbsp;("+uniqueCounts.meta_data_ids.size+")")
$("#packed_dataset_count").html("&nbsp;("+uniqueCounts.data_set_ids.size+")")
$("#packed_enviornment_count").html("&nbsp;("+uniqueCounts.env_ids.size+")")
$("#packed_datasource_count").html("&nbsp;("+uniqueCounts.integration_ids.size+")")

      let svg = d3.select("#"+pmId).append("svg"),
       margin = 80,
       diameter = +$("#"+pmId).width(),
       width  = $("#"+pmId).width() ===0 ? 670 : $("#"+pmId).width(),
       height  = $("#"+pmId).height();
       let g = svg
         .attr("width",width)
         .attr("height",height)
         .attr("viewBox", `-${width / 2} -${height / 2} ${width} ${height}`)
         .append("g")
         // .attr("transform", "translate(" + diameter / 2 + "," + diameter / 2 + ")");
    //  var colors = d3
    //    .scaleLinear()
    //    .domain([-1, 5])
    //    .range(["hsl(152,80%,80%)", "hsl(228,30%,40%)","hsl(259.74, 92.81%, 67.25%)"])
    //   //.range(["hsl(179, 46%, 45%)", "hsl(210, 51%, 58%)"])
    //    .interpolate(d3.interpolateHcl);
//     var color = ["rgb(76, 163, 255)","rgb(246, 78, 96)","rgb(255, 168, 0)","rgb(78, 210, 204)"];
//,"rgb(237,246,255)",

// var color = [
//              "rgb(255, 255, 255)",
//              "rgb(246, 78, 96)",
//              "rgb(255, 168, 0)",
//              "rgb(78, 210, 204)"];


function setColorScheme(multi){
        if (multi) {
          // let color = d3.scaleOrdinal()
          //   .range(d3.schemeCategory10)
          //let col = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"]
          let color = d3.scaleOrdinal()
            .range(["white", "#51B7AE", "#5D94CB", "#BF73AA", "#6395A6", "#65C0DD", "#E99380", "#71DBD6", "#AAAAAA", "#FCB760", "#AC86FA"])
          return color;
        }
      }
      
      
      let color = setColorScheme(multicolor);
    
      console.log("#####")
      console.log(color)
      
      
      function setCircleColor(obj) {
        let depth = obj.depth;
        while (obj.depth > 1) {
          obj = obj.parent;
        }
        
        let newcolor = multicolor ? d3.hsl(color(obj.data.name)) : d3.hsl(hexcolor);
        newcolor.l += depth === 1 ? 0 : depth * .1;
        if(obj.parent === null){
        newcolor = d3.hsl("white");
        }
        return newcolor;
      }
    
      function setStrokeColor(obj) {
        let depth = obj.depth;
        while (obj.depth > 1) {
          obj = obj.parent;
        }
        let strokecolor = multicolor ? d3.hsl(color(obj.data.name)) : d3.hsl(hexcolor);
        if(obj.parent == null){
          strokecolor = d3.hsl("white");
        }
        if(depth===4){
          strokecolor = String(strokecolor).replace("rgb","rgba");
          strokecolor = String(strokecolor).replace(")",',0.5)');
          return strokecolor;
        }
        return "";
      }

     var pack = d3
       .pack()
       .size([diameter - margin, diameter - margin])
       .padding(50);
     //root = {"name":"flare","children":[{"name":"analytics","children":[{"name":"cluster","children":[{"name":"AgglomerativeCluster","size":39},{"name":"CommunityStructure","size":38},{"name":"HierarchicalCluster","size":67},{"name":"MergeEdge","size":74}]},{"name":"graph","children":[{"name":"BetweennessCentrality","size":35},{"name":"LinkDistance","size":57},{"name":"MaxFlowMinCut","size":78},{"name":"ShortestPaths","size":59},{"name":"SpanningTree","size":34}]},{"name":"optimization","children":[{"name":"AspectRatioBanker","size":70}]}]},{"name":"animate","children":[{"name":"Easing","size":17},{"name":"FunctionSequence","size":58},{"name":"interpolate","children":[{"name":"ArrayInterpolator","size":19},{"name":"ColorInterpolator","size":20},{"name":"DateInterpolator","size":13},{"name":"Interpolator","size":87},{"name":"MatrixInterpolator","size":22},{"name":"NumberInterpolator","size":13},{"name":"ObjectInterpolator","size":16},{"name":"PointInterpolator","size":16},{"name":"RectangleInterpolator","size":20}]},{"name":"ISchedulable","size":10},{"name":"Parallel","size":51},{"name":"Pause","size":44},{"name":"Scheduler","size":55},{"name":"Sequence","size":55},{"name":"Transition","size":92},{"name":"Transitioner","size":19},{"name":"TransitionEvent","size":11},{"name":"Tween","size":60}]},{"name":"data","children":[{"name":"converters","children":[{"name":"Converters","size":72},{"name":"DelimitedTextConverter","size":42},{"name":"GraphMLConverter","size":98},{"name":"IDataConverter","size":13},{"name":"JSONConverter","size":22}]},{"name":"DataField","size":17},{"name":"DataSchema","size":21},{"name":"DataSet","size":58},{"name":"DataSource","size":33},{"name":"DataTable","size":77},{"name":"DataUtil","size":33}]},{"name":"display","children":[{"name":"DirtySprite","size":88},{"name":"LineSprite","size":17},{"name":"RectSprite","size":36},{"name":"TextSprite","size":10}]},{"name":"flex","children":[{"name":"FlareVis","size":41}]},{"name":"physics","children":[{"name":"DragForce","size":10},{"name":"GravityForce","size":13},{"name":"IForce","size":31},{"name":"NBodyForce","size":10},{"name":"Particle","size":28},{"name":"Simulation","size":99},{"name":"Spring","size":22},{"name":"SpringForce","size":16}]},{"name":"query","children":[{"name":"AggregateExpression","size":16},{"name":"And","size":10},{"name":"Arithmetic","size":38},{"name":"Average","size":89},{"name":"BinaryExpression","size":28},{"name":"Comparison","size":51},{"name":"CompositeExpression","size":36},{"name":"Count","size":78},{"name":"DateUtil","size":41},{"name":"Distinct","size":93},{"name":"Expression","size":51},{"name":"ExpressionIterator","size":36},{"name":"Fn","size":32},{"name":"If","size":27},{"name":"IsA","size":20},{"name":"Literal","size":12},{"name":"Match","size":37},{"name":"Maximum","size":84},{"name":"methods","children":[{"name":"add","size":59},{"name":"and","size":33},{"name":"average","size":28},{"name":"count","size":27},{"name":"distinct","size":29},{"name":"div","size":59},{"name":"eq","size":59},{"name":"fn","size":46},{"name":"gt","size":60},{"name":"gte","size":62},{"name":"iff","size":74},{"name":"isa","size":46},{"name":"lt","size":59},{"name":"lte","size":61},{"name":"max","size":28},{"name":"min","size":28},{"name":"mod","size":59},{"name":"mul","size":60},{"name":"neq","size":59},{"name":"not","size":38},{"name":"or","size":32},{"name":"orderby","size":30},{"name":"range","size":77},{"name":"select","size":29},{"name":"stddev","size":36},{"name":"sub","size":60},{"name":"sum","size":28},{"name":"update","size":30},{"name":"variance","size":33},{"name":"where","size":29},{"name":"xor","size":35},{"name":"_","size":264}]},{"name":"Minimum","size":84},{"name":"Not","size":15},{"name":"Or","size":97},{"name":"Query","size":13},{"name":"Range","size":15},{"name":"StringUtil","size":41},{"name":"Sum","size":79},{"name":"Variable","size":11},{"name":"Variance","size":18},{"name":"Xor","size":11}]},{"name":"scale","children":[{"name":"IScaleMap","size":21},{"name":"LinearScale","size":13},{"name":"LogScale","size":31},{"name":"OrdinalScale","size":37},{"name":"QuantileScale","size":24},{"name":"QuantitativeScale","size":48},{"name":"RootScale","size":17},{"name":"Scale","size":42},{"name":"ScaleType","size":18},{"name":"TimeScale","size":58}]},{"name":"util","children":[{"name":"Arrays","size":82},{"name":"Colors","size":10},{"name":"Dates","size":82},{"name":"Displays","size":12},{"name":"Filter","size":23},{"name":"Geometry","size":10},{"name":"heap","children":[{"name":"FibonacciHeap","size":93},{"name":"HeapNode","size":12}]},{"name":"IEvaluable","size":33},{"name":"IPredicate","size":38},{"name":"IValueProxy","size":87},{"name":"math","children":[{"name":"DenseMatrix","size":31},{"name":"IMatrix","size":28},{"name":"SparseMatrix","size":33}]},{"name":"Maths","size":17},{"name":"Orientation","size":14},{"name":"palette","children":[{"name":"ColorPalette","size":63},{"name":"Palette","size":12},{"name":"ShapePalette","size":20},{"name":"SizePalette","size":22}]},{"name":"Property","size":55},{"name":"Shapes","size":19},{"name":"Sort","size":68},{"name":"Stats","size":65},{"name":"Strings","size":22}]},{"name":"vis","children":[{"name":"axis","children":[{"name":"Axes","size":13},{"name":"Axis","size":24},{"name":"AxisGridLine","size":65},{"name":"AxisLabel","size":63},{"name":"CartesianAxes","size":67}]},{"name":"controls","children":[{"name":"AnchorControl","size":21},{"name":"ClickControl","size":38},{"name":"Control","size":13},{"name":"ControlList","size":46},{"name":"DragControl","size":26},{"name":"ExpandControl","size":28},{"name":"HoverControl","size":48},{"name":"IControl","size":76},{"name":"PanZoomControl","size":52},{"name":"SelectionControl","size":78},{"name":"TooltipControl","size":84}]},{"name":"data","children":[{"name":"Data","size":20},{"name":"DataList","size":19},{"name":"DataSprite","size":10},{"name":"EdgeSprite","size":33},{"name":"NodeSprite","size":19},{"name":"render","children":[{"name":"ArrowType","size":69},{"name":"EdgeRenderer","size":55},{"name":"IRenderer","size":35},{"name":"ShapeRenderer","size":22}]},{"name":"ScaleBinding","size":11},{"name":"Tree","size":71},{"name":"TreeBuilder","size":99}]},{"name":"events","children":[{"name":"DataEvent","size":23},{"name":"SelectionEvent","size":18},{"name":"TooltipEvent","size":17},{"name":"VisualizationEvent","size":11}]},{"name":"legend","children":[{"name":"Legend","size":20},{"name":"LegendItem","size":46},{"name":"LegendRange","size":10}]},{"name":"operator","children":[{"name":"distortion","children":[{"name":"BifocalDistortion","size":44},{"name":"Distortion","size":63},{"name":"FisheyeDistortion","size":34}]},{"name":"encoder","children":[{"name":"ColorEncoder","size":31},{"name":"Encoder","size":40},{"name":"PropertyEncoder","size":41},{"name":"ShapeEncoder","size":16},{"name":"SizeEncoder","size":18}]},{"name":"filter","children":[{"name":"FisheyeTreeFilter","size":52},{"name":"GraphDistanceFilter","size":31},{"name":"VisibilityFilter","size":35}]},{"name":"IOperator","size":12},{"name":"label","children":[{"name":"Labeler","size":99},{"name":"RadialLabeler","size":38},{"name":"StackedAreaLabeler","size":32}]},{"name":"layout","children":[{"name":"AxisLayout","size":67},{"name":"BundledEdgeRouter","size":37},{"name":"CircleLayout","size":93},{"name":"CirclePackingLayout","size":12},{"name":"DendrogramLayout","size":48},{"name":"ForceDirectedLayout","size":84},{"name":"IcicleTreeLayout","size":48},{"name":"IndentedTreeLayout","size":31},{"name":"Layout","size":78},{"name":"NodeLinkTreeLayout","size":12},{"name":"PieLayout","size":27},{"name":"RadialTreeLayout","size":12},{"name":"RandomLayout","size":87},{"name":"StackedAreaLayout","size":91},{"name":"TreeMapLayout","size":91}]},{"name":"Operator","size":24},{"name":"OperatorList","size":52},{"name":"OperatorSequence","size":41},{"name":"OperatorSwitch","size":25},{"name":"SortOperator","size":20}]},{"name":"Visualization","size":16}]}]}
     //alert(root);
     //root = {"name":"flare","children":[{"children":[{"children":[{"children":[{"name":"marks","size":1},{"name":"name","size":1}],"data_set_id":27808,"name":"dqsample.csv"}],"integration_id":1404,"name":"DQ_Reports"},{"children":[{"children":[{"name":"BloodPressure","size":1},{"name":"Insulin","size":1}],"data_set_id":27608,"name":"health care diabetes.csv"},{"children":[{"name":"Outcome","size":1}],"data_set_id":27607,"name":"Prediction.csv"}],"integration_id":1338,"name":"Dev_Retail"}],"env_id":1190,"name":"dq-reports"},{"children":[{"children":[{"children":[{"name":"BloodPressure","size":1},{"name":"Insulin","size":1}],"data_set_id":27249,"name":"health care diabetes.csv"}],"integration_id":1232,"name":"Retail"}],"env_id":1149,"name":"Qualdo-dev"}]}
     root = d3
         .hierarchy(root)
         .sum(function (d) {
           return d.size;
         })
         .sort(function (a, b) {
           return b.value - a.value;
         });
     
       var focus = root,
         nodes = pack(root).descendants(),
         view;
     
let tip = d3.tip()
.attr('class', 'd3-tip')
.direction('e')
.offset([0,5])
.html(function(d,i) {
  if(d.depth > 0){
  // console.clear();
  // console.log(d)
  // alert(JSON.stringify(d))
    return getToolTipContentPackedChart(d,i,chatdata);
  }
});
svg.call(tip);

       var circle = g
         .selectAll("circle")
         .data(nodes)
         .enter()
         .append("circle")
         .attr("class", function(d) { return d.parent ? d.children ? "node" : "node node--leaf" : "node node--root"; })
         .attr("fill", setCircleColor)
         .attr("stroke", setStrokeColor)
         /*.attr("class", function (d) {
           return d.parent
             ? d.children
               ? "node"
               : "node node--leaf leaft_partent_id_"+d.data.data_set_id
             : "node node--root";
         })
         .style("fill", function (d) {
          //  console.log(d.data.env_id);
          let index = env_ids.indexOf(d.data.env_id);
          let color;
            // indexOf
           if(d.depth === 1){
            color = color_depth_1;
           }
           else if(d.depth === 2){
            color =  color_depth_2;
           }
           else if(d.depth === 3){
            color =   color_depth_3 ;
           }
           else if(d.depth === 4){
            color =  color_depth_4;
           }
           if(color!==undefined){
              return d.children ? color[index] : color[index];
           }else {
            return "rgb(255, 255, 255)";
           }
         })
         .style("fill-opacity", function (d) {
          // console.log("-----------")  
          // console.log(d)
            // d.depth
            // if(d.depth===1){
            //   return "0.7";
            // }
            // if(d.depth===2){
            //   return "0.5";
            // }
            // if(d.depth===3){
            //   return "0.1";
            // }
           
          })
         .style("stroke", function (d) {
          //return d.children ? color[d.depth] : null;
          return d.children ? 'rgb(0, 0, 0)' : null;
        })*/
        .style("stroke-width", function (d) {
          if(d.depth === 0) return "0px";
          return "1px";
        })
         .on("click", function (d) {
            if (focus !== d){
                zoom(d);
               currentEvent.stopPropagation(); 
               }
         })
         .on('mouseover', tip.show)
         .on('mouseout', tip.hide)
     
      //  g
      //    .selectAll("text")
      //    .data(nodes)
      //    .enter()
      //    .append("text")
      //    //.attr("class", "label ")
      //   //  .style("fill-opacity", function (d) {
      //   //    return d.parent === root ? 0.6 : 0;
      //   //  })
      //    .style("display", function (d) {
      //      return d.parent === root ? "inline" : "none";
      //    })
      //    .style("font-size", function (d) {
      //       return "24px";
      //    })
      //    .attr("x",function (d) { return -d.r/6;})
      //    .attr("y",function (d) {
      //     if(d.depth ===1)
      //       {
      //         return -d.r;
      //       }
      //       if(d.depth ===2)
      //       {
      //         return -d.r;
      //       }
      //       if(d.depth ===3)
      //       {
      //         return -d.r;
      //       }
      //       if(d.depth ===4)
      //       {
      //         return -d.r;
      //       }

      //      })
      //    .text(function (d) {
      //     if(d.data.name!=="packed-chart"){
      //      return d.data.size === undefined ? 
      //      d.data.name : d.data.name+" ("+d.data.size+")";
      //     }
      //    });


      g.selectAll("foreignObject")
.data(nodes)
.enter()
.append("foreignObject")
.attr("class", "node-label")
.attr("width", function (d) { return 200 })
.attr("height", function (d) { return 20 })

// .attr("width", function (d) { return d.r * 2; })
// .attr("height", function (d) { return d.r * 2; })
// .attr("x", function (d) { return -d.r; })
// .attr("y", function (d) { return -d.r; })
        //  .attr("x",function (d) { return -d.r/6;})
        .attr("x", function (d) { return -100; })
         .attr("y",function (d) {
          if(d.depth ===1)
            {
              return -d.r- 20;;
            }
            if(d.depth ===2)
            {
              return -d.r- 20;;
            }
            if(d.depth ===3)
            {
              return -d.r- 20;;
            }
            if(d.depth ===4)
            {
              return -d.r;
            }

           })
.style("display", function (d) {
  return d.parent === root ? "inline" : "none";
})
.append("xhtml:div")
.style("width", "100%")
.style("height", "100%")
.style("display", "flex")
.style("align-items", "center")
.style("justify-content", "center")
.style("font-size", function (d) {
  return "24px";
})
.html(function (d) {
  if (d.data.name !== "packed-chart") {
    let icon = ''
    if(d.depth ===1)
      {
        icon = environment_icon
      }
      else if(d.depth ===2)
      {
        icon = datasource_icon
      }
      else if(d.depth ===3)
      {
        icon = dataset_icon
      }
    return d.data.size === undefined ? 
`<img width='20px' height='20px' src='data:image/svg+xml;utf8,`+icon+`'/>`+d.data.name : d.data.name + " (" + d.data.size + ")";
  }
});

     
       var node = g.selectAll("circle");
       var textnode = g.selectAll("foreignObject");

     
      // svg.style("background", color(-1)).on("click", function () {
        svg.style("background", 'rgb(255, 255, 255)').on("click", function () {
         zoom(root);
       });
     
       zoomTo([root.x, root.y, root.r * 2 + margin]);
     
       function zoom(d) {
        // if(d.depth === 3){
        //   if(d.parent!==null){
        //     $(".leaft_partent_id_"+d.data.data_set_id).css({"display":"block","stroke-width":"1px","fill":"rgba(78, 210, 204, 0.8)",
        //     "fill-opacity":"1"});
        //   }
        // }
        // else {
        //   $(".node--leaf").css({"display":"none"});
        // }

        if(d.depth === 4){
          return;
        }
        //  var focus0 = focus;
         focus = d;
         var transition = d3
           .transition()
           .duration(currentEvent.altKey ? 7500 : 750)
           .tween("zoom", function (d) {
             var i = d3.interpolateZoom(view, [
               focus.x,
               focus.y,
               focus.r * 2 + margin
             ]);
             return function (t) {
               zoomTo(i(t));
             };
           });
     
         transition
           .selectAll("#packedChart foreignObject")
           .filter(function (d) {
             return d.parent === focus || this.style.display === "inline";
           })
        .style("font-size", function (d) {
          if(d.depth === 0){
            return "24px";
          }
          if(d.depth === 1){
            return "24px";
          }
          if(d.depth === 2){
            return "18px";
          }
          if(d.depth === 3){
            return "16px";
          }
        })

          //  .style("fill-opacity", function (d) {
          //    return d.parent === focus ? 1 : 0;
          //  })
           .on("start", function (d) {
             if (d.parent === focus) this.style.display = "inline";
           })
           .on("end", function (d) {
             if (d.parent !== focus) this.style.display = "none";
           });
       }
     
       function zoomTo(v) {
         var k = diameter / v[2];
         view = v;
         textnode.attr("transform", function (d) {
          // console.log("*********")
          // console.log(d)
          // console.log(v)
          // console.log("*********")
          // if(d.data.name === "Patch"){
          //   return "translate(" + (d.x - v[0]) * k + "," +"-235" * k + ")";
          // }
          // if(d.data.name === "Production"){
          //   return "translate(" + (d.x - v[0]) * k + "," +"-55" * k + ")";
          // }
          // if(d.data.name === "Commerce data"){
          //   return "translate(" + (d.x - v[0]) * k + "," +"-105" * k + ")";
          // }
          // if(d.data.name === "Business data"){
          //   return "translate(" + (d.x - v[0]) * k + "," +"-115" * k + ")";
          // }
          // if(d.data.name === "135test.csv"){
          //   return "translate(" + (d.x - v[0]) * k + "," +"-35" * k + ")";
          // }
          // if(d.data.name === "133test.csv"){
          //   return "translate(" + (d.x - v[0]) * k + "," +"-35" * k + ")";
          // }
          // if(d.data.name === "131test.csv"){
          //   return "translate(" + (d.x - v[0]) * k + "," +"-90" * k + ")";
          // }
         // 131test.csv
          //Commerce data
          //Business data
          //135test.csv
          //133test.csv
          // if(d.data.name === "Production"){
          //   return "translate(" + (d.x - v[0]) * k + "," +"-65" * k + ")";
          // }

          return "translate(" + (d.x - v[0]) * k + "," + (d.y - v[1]) * k + ")";

//          return "translate(" + (d.x - v[0]) * k + "," + (d.y - v[1]) * k + ")";
          //return "translate(" + (d.x - v[0]) * k + "," + (d.y - v[1]) * k + ")";
        });
         node.attr("transform", function (d) {
           return "translate(" + (d.x - v[0]) * k + "," + (d.y - v[1]) * k + ")";
         });
         circle.attr("r", function (d) {
           return d.r * k;
         });
       }
     } 

heatmapenvdataqualityissue(){
  $("#"+this.props.chartid).html("");
  let mapstr = '';
  let finalmapstr = '';
  let prevenv = '';
  let trends;
  let data = this.props.chartdata;
  let arraycheck = [];
  let formatData = [];
  $.each(data.env_heat_map, function(i, item) {
    if(arraycheck.indexOf(item.environment)===-1){
      arraycheck.push(item.environment)
      let filterArr = $(data.env_heat_map)
          .filter(function (i,n){
              return n.environment===item.environment;
          })
          for(let loop=0;loop<filterArr.length;loop++){
            formatData.push(filterArr[loop]);
          }
    }
  })
  $.each(formatData, function(i, item) {
    if(i===0){
      $("#dataqualityissuebyenviromentthismonth").html(getDateFormat(item.duration))
    }else if(i===1){
      $("#dataqualityissuebyenviromentpreviousmonth").html(getDateFormat(item.duration))
    }else if(i===2){
      $("#dataqualityissuebyenviromentpreviousofpreviousmonth").html(getDateFormat(item.duration))
    }
      let count_percentage = '';
      if(item.value!=="NA"){
        count_percentage = ` (`+item.value+`%) `+item.issue_count;
      }else {
        count_percentage = `NA`;
      }
      if(item.trends=== "neutral"){
        trends = ""
      }
      else if(item.trends === "up"){
        trends = "caret caret-up"
      }
      else if(item.trends === "down"){
        trends = "caret caret-down"
      }

      if(prevenv === item.environment){
        mapstr += `
        <td data-row='`+JSON.stringify(item)+`' class="text-black heatmap-tooltip" style='background-color: `+getHeatMapColorCode((item.value))+`'}}><span
          class="`+trends+`"></span> `+count_percentage+`</td>`;
      }else {
        if(mapstr!==""){
          finalmapstr += `<tr>`+mapstr+`</tr>`;
        }
        mapstr = `<td data-row='`+JSON.stringify(item)+`' class"text-dark heatmap-tooltip">`+  getmappingvalue("environments",item.environment,data)
        +`</td>
        <td  data-row='`+JSON.stringify(item)+`' class="text-black heatmap-tooltip" style='background-color:`+getHeatMapColorCode((item.value))+`'><span
          class="`+trends+`"></span>`+count_percentage+`</td>`;
      }
  prevenv = item.environment;
  });
  if(mapstr!==""){
    finalmapstr += `<tr>`+mapstr+`</tr>`;
  }
  $("#"+this.props.chartid).html(finalmapstr);

  $(".heatmap-tooltip").mouseover(function(e){
    var relX = e.pageX;
    var relY = e.pageY;
    let jsonrow = JSON.parse($(this).attr("data-row")); 
    $("#heat_map_tooltip").html(`<div class="d3-tip__header">`+getmappingvalue("environments",jsonrow.environment,data)+`</div>
    <div class="d3-tip__body">
        <div class="d3-tip__section">
        <p><label>Environment:</label> `+getmappingvalue("environments",jsonrow.environment,data)+`</p>
        <p><label>Period:</label>`+getDateFormat(jsonrow.duration)+`</p>
        <p><label>Total Number of Data Quality Issues:</label>`+jsonrow.issue_count+`</p>
        <p><label>Total Number of Data Quality Issues in Previous Month:</label>`+jsonrow.prev_issue_count+`</p>
        </div>
     </div>`);
    $("#heat_map_tooltip").show();
    $("#heat_map_tooltip").css({"position":"absoulte","top":(relY)+"px","opacity": "1", "pointer-events": "all", "box-sizing": "border-box", "left":(relX)+"px","z-index":9999});
  });

  $(".heatmap-tooltip").mouseleave(function(){
    //let position = $(this).position();
    // $("#heat_map_tooltip").hide();
    $("#heat_map_tooltip").css({"position":"absoulte","top":"0px","opacity": "0", "pointer-events": "all", "box-sizing": "border-box", "left":"1px","z-index":9999});

  });
}

dataqualityissuebydatasetheatmap(){
  let mapstr = '';
  let finalmapstr = '';
  let prevenv = '';
  let trends;
  let data = this.props.chartdata;

  let arraycheck = [];
  let formatData = [];
  $.each(data.data_set_heat_map, function(i, item) {
    if(arraycheck.indexOf(item.dataset)===-1){
      arraycheck.push(item.dataset)
      let filterArr = $(data.data_set_heat_map)
          .filter(function (i,n){
              return n.dataset===item.dataset;
          })
          for(let loop=0;loop<filterArr.length;loop++){
            formatData.push(filterArr[loop]);
          }
    }
  })

  $.each(formatData, function(i, item) {
    if(i===0){
      $("#dataqualityissuebydatasetthismonth").html(getDateFormat(item.duration))
    }else if(i===1){
      $("#dataqualityissuebydatasetpreviousmonth").html(getDateFormat(item.duration))
    }else if(i===2){
      $("#dataqualityissuebydatasetpreviousofpreviousmonth").html(getDateFormat(item.duration))
    }
      let count_percentage = '';
      if(item.value!=="NA"){
        count_percentage = ` (`+item.value+`%) `+item.issue_count;
      }else {
        count_percentage = `NA`;
      }

      if(item.trends=== "neutral"){
        trends = ""
      }
      else if(item.trends=== "up"){
        trends = "caret caret-up"
      }
      else if(item.trends=== "down"){
        trends = "caret caret-down"
      }

      if(prevenv===item.dataset){
        mapstr += `
        <td data-row='`+JSON.stringify(item)+`' class="text-black heatmap-tooltip-dataset" style='background-color: `+getHeatMapColorCode((item.value))+`'}}><span
          class="`+trends+`"></span> `+count_percentage+`</td>`;
      }else {
        if(mapstr!==""){
          finalmapstr += `<tr>`+mapstr+`</tr>`;
        }
        mapstr = `<td data-row='`+JSON.stringify(item)+`'>`+getmappingvalue("environments",item.env_id,data)+` > `+getmappingvalue("integrations",item.integration_id,data)+`</td>`
        mapstr += `<td data-row='`+JSON.stringify(item)+`'  class"text-dark heatmap-tooltip-dataset">`+  getmappingvalue("datasets",item.dataset,data)
        +`</td>
        <td data-row='`+JSON.stringify(item)+`' class="text-black heatmap-tooltip-dataset" style='background-color:`+getHeatMapColorCode((item.value))+`'><span
          class="`+trends+`"></span>`+count_percentage+`</td>`;
      }
  prevenv = item.dataset;
  });
  if(mapstr!==""){
    finalmapstr += `<tr>`+mapstr+`</tr>`;
  }
  $("#"+this.props.chartid).html(finalmapstr);

  $(".heatmap-tooltip-dataset").mouseover(function(e){
    var relX = e.pageX;
    var relY = e.pageY;
    let jsonrow = JSON.parse($(this).attr("data-row"));
    $("#heat_map_tooltip").html(`<div class="d3-tip__header">`+getmappingvalue("datasets",jsonrow.dataset,data)+`</div>
    <div class="d3-tip__body">
        <div class="d3-tip__section">
        <p><label>Environment:</label> `+getmappingvalue("environments",jsonrow.env_id,data)+`</p>
        <p><label>Datasource:</label> `+getmappingvalue("integrations",jsonrow.integration_id,data)+`</p>
        <p><label>Dataset:</label> `+getmappingvalue("datasets",jsonrow.dataset,data)+`</p>
        <p><label>Duration:</label>`+getDateFormat(jsonrow.duration)+`</p>
        <p><label>Total Number of Data Quality Issues:</label>`+jsonrow.issue_count+`</p>
        <p><label>Total Number of Data Quality Issues in Previous Month:</label>`+jsonrow.prev_issue_count+`</p>
        </div>
     </div>`);
    $("#heat_map_tooltip").show();
    $("#heat_map_tooltip").css({"position":"absoulte","top":(relY)+"px","opacity": "1", "pointer-events": "all", "box-sizing": "border-box", "left":(relX)+"px","z-index":9999});
  });

  $(".heatmap-tooltip-dataset").mouseleave(function(){
    $("#heat_map_tooltip").css({"position":"absoulte","top":"0px","opacity": "0", "pointer-events": "all", "box-sizing": "border-box", "left":"1px","z-index":9999});
  });
}

dataqualityissuebyattributeheatmap(){
  let mapstr = '';
  let finalmapstr = '';
  let prevenv = '';
  let trends = '';
  let data = this.props.chartdata;
  
  let arraycheck = [];
  let formatData = [];
  $.each(data.attribute_heat_map, function(i, item) {
    if(arraycheck.indexOf(item.attribute)===-1){
      arraycheck.push(item.attribute)
      let filterArr = $(data.attribute_heat_map)
          .filter(function (i,n){
              return n.attribute===item.attribute;
          })
          for(let loop=0;loop<filterArr.length;loop++){
            formatData.push(filterArr[loop]);
          }
    }
  })
  $.each(formatData, function(i, item) {
    if(i===0){
      $("#dataqualityissuebyattributethismonth").html(getDateFormat(item.duration))
    }else if(i===1){
      $("#dataqualityissuebyattributepreviousmonth").html(getDateFormat(item.duration))
    }else if(i===2){
      $("#dataqualityissuebyattributepreviousofpreviousmonth").html(getDateFormat(item.duration))
    }
    let count_percentage = '';
    if(item.value!=="NA"){
      count_percentage = ` (`+item.value+`%) `+item.issue_count;
    }else {
      count_percentage = `NA`;
    }

    if(item.trends=== "neutral"){
      trends = ""
    }
    else if(item.trends=== "up"){
      trends = "caret caret-up"
    }
    else if(item.trends=== "down"){
      trends = "caret caret-down"
    }

    if(prevenv===item.attribute){
        mapstr += `
        <td data-row='`+JSON.stringify(item)+`' class="text-black heatmap-tooltip-attribute" style='background-color: `+getHeatMapColorCode((item.value))+`'}}><span
          class="`+trends+`"></span>`+count_percentage+`</td>`;
      }else {
        if(mapstr!==""){
          finalmapstr += `<tr>`+mapstr+`</tr>`;
        }
        mapstr = `<td >`+getmappingvalue("environments",item.env_id,data)+` > `+getmappingvalue("integrations",item.integration_id,data)+`</td>
                  <td>`+getmappingvalue("datasets",item.data_set_id,data)+`</td>
                  <td data-row='`+JSON.stringify(item)+`'  class"text-dark heatmap-tooltip-attribute">`+  getmappingvalue("metadata",item.attribute,data)+`</td>
                  <td data-row='`+JSON.stringify(item)+`' class="text-black heatmap-tooltip-attribute" style='background-color:`+getHeatMapColorCode((item.value))+`'><span class="`+trends+`"></span>`+count_percentage+`</td>`;
      }
  prevenv = item.attribute;
  });
  if(mapstr!==""){
    finalmapstr += `<tr>`+mapstr+`</tr>`;
  }
  $("#"+this.props.chartid).html(finalmapstr);

  $(".heatmap-tooltip-attribute").mouseover(function(e){
    var relX = e.pageX;
    var relY = e.pageY;
    let jsonrow = JSON.parse($(this).attr("data-row"));
    $("#heat_map_tooltip").html(`<div class="d3-tip__header">`+getmappingvalue("metadata",jsonrow.attribute,data)+`</div>
    <div class="d3-tip__body">
        <div class="d3-tip__section">
        <p><label>Environment:</label> `+getmappingvalue("environments",jsonrow.env_id,data)+`</p>
        <p><label>Datasource:</label> `+getmappingvalue("integrations",jsonrow.integration_id,data)+`</p>
        <p><label>Dataset:</label> `+getmappingvalue("datasets",jsonrow.data_set_id,data)+`</p>
        <p><label>Attribute:</label> `+getmappingvalue("metadata",jsonrow.attribute,data)+`</p>
        <p><label>Duration:</label>`+getDateFormat(jsonrow.duration)+`</p>
        <p><label>Total Number of Data Quality Issues:</label>`+jsonrow.issue_count+`</p>
        <p><label>Total Number of Data Quality Issues in Previous Month:</label>`+jsonrow.prev_issue_count+`</p>
        </div>
     </div>`);
    $("#heat_map_tooltip").show();
    $("#heat_map_tooltip").css({"position":"absoulte","top":(relY)+"px","opacity": "1", "pointer-events": "all", "box-sizing": "border-box", "left":(relX)+"px","z-index":9999});
  });

  $(".heatmap-tooltip-attribute").mouseleave(function(){
    $("#heat_map_tooltip").css({"position":"absoulte","top":"0px","opacity": "0", "pointer-events": "all", "box-sizing": "border-box", "left":"1px","z-index":9999});
  });

}

heatmapcolorlegend(pmId) {
  $("#"+pmId).html("");

  /// .replace("> 100",100)
  var extent = d3.extent(custom_dq_heat_map_colors, d => d.value);
  var padding = 15;
  var width = 320;
  var innerWidth = width - (padding * 3);
  var barHeight = 10;
  var height = 28;

  var xScale = d3.scaleLinear()
      .range([0, innerWidth])
      .domain(extent);
  // var xTicks = custom_dq_heat_map_colors.filter(f => f.value % 10 === 0).map(d => d.value);
  var xAxis = d3.axisBottom(xScale)
      .tickSize(15)
      .tickFormat((d, i) => d > 90 ? String(d).replace("100",">100") : d);

  var svg = d3.select("#"+pmId).append("svg").attr("width", width).attr("height", height);
  svg.selectAll("*").remove();
  var g = svg.append("g").attr("transform", "translate(" + padding + ", 0)");

  var defs = svg.append("defs");
  var linearGradient = defs.append("linearGradient").attr("id", "myGradient");
  linearGradient.selectAll("stop")
      .data(custom_dq_heat_map_colors)
    .enter().append("stop")
      .attr("offset", d => ((String(d.value).replace("> 100",100) - extent[0]) / (extent[1] - extent[0]) * 100) + "%")
      //.attr("stop-color", d => d.color);
      .attr("stop-color", d => (getHeatMapColorCode(String(d.value).replace("> 100",100))))
  g.append("rect")
      .attr("width", innerWidth)
      .attr("height", barHeight)
      .style("fill", "url(#myGradient)");

  g.append("g")
      .call(xAxis)
     .select(".domain").remove();
  
}

sunbrustchart(pmData,type) {
  $("#"+this.props.chartid).html("");
    const width = 800;
    const radius = width / 6;
    const arc = d3.arc()
            .startAngle(d => d.x0)
            .endAngle(d => d.x1)
            .padAngle(d => Math.min((d.x1 - d.x0) / 2, 0.005))
            .padRadius(radius * 1.5)
            .innerRadius(d => d.y0 * radius)
            .outerRadius(d => Math.max(d.y0 * radius, d.y1 * radius - 1));
    const partition = data => {
        const root = d3.hierarchy(data)
                .sum(d => d.size)
                .sort((a, b) => b.value - a.value);
        return d3.partition()
                .size([2 * Math.PI, root.height + 1])
                (root);
    };
let data = pmData;
const root = partition(data);
        let color = d3.scaleOrdinal().range(d3.quantize(d3.interpolateRainbow, data.children.length + 1));
        root.each(d => d.current = d);
        if(type==="env"){
          color = environment_sunbrust_color;
        }
        else if(type==="datasource"){
          color = datasource_sunbrust_color
        }
        else if(type==="dataset"){
          color = datset_sunbrust_color
        }
        else{ // attribute
          color = attribute_sunbrust_color
        }

        const svg = d3.select('#'+this.props.chartid)
                .append("svg")
                .attr("viewBox","0 0 "+width+" "+width)
                .style("width", "100%")
                .style("height", "100%")
                .style("font-size", "16px")
                .style("font-weight","500")
                .style("font-family","'Poppins', sans-serif");

                
        const g = svg.append("g")
                .attr("transform", `translate(${width / 2},${width / 2})`);

        let tip = d3.tip()
                .attr('class', 'd3-tip')
                .direction('e')
                .offset([0,5])
                .html(function(d,i) {
                    return getToolTipContentSunBrust(d,i,type);
                });
        svg.call(tip);     
        
        
        let tipinner = d3.tip()
        .attr('class', 'd3-tip')
        .direction('e')
        .offset([0,5])
        .html(function(d,i) {
            return getToolTipContentSunBrustInner(d,i,type);
        });
        svg.call(tipinner);     
        

        g.append('text')
        .attr('class', 'toolCircle')
        .attr('dy', -10) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
        .html('Data Quality') // add text to the circle.
        .style('font-size', '18px')
        .style('font-weight', 'bold')
        .style('color', '#484848')
        .style('text-anchor', 'middle');
        
        g.append('text')
        .attr('class', 'toolCircle')
        .attr('dy', 15) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
        .html('Issues') // add text to the circle.
        .style('font-size', '18px')
        .style('font-weight', 'bold')
        .style('color', '#484848').style('text-anchor', 'middle');

        g.append('text')
        .attr('class', 'toolCircle')
        .attr('dy', 40) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
        // .html('May 2023') // add text to the circle.
        // .html(this.props.monthviewmonth+" "+this.props.monthviewyear)
        .style('font-size', '18px')
        .style('font-weight', 'bold')
        .style('color', '#484848')
        .style('text-anchor', 'middle');


        g.append('text')
        .attr('id', 'selecteditem_'+this.props.chartid)
        .attr('class', 'toolCircle')
        .attr('dy', 65) // hard-coded. can adjust this to adjust text vertical alignment in tooltip
        .html('') // add text to the circle.
        .style('font-size', '18px')
        .style('font-weight', 'bold')
        .style('color', '#484848')
        .style('text-anchor', 'middle');

        const path = g.append("g")
                .selectAll("path")
                .data(root.descendants().slice(1))
                .join("path")
                // .attr("fill", d => {
                //     while (d.depth > 1)
                //         { d = d.parent; }
                //         alert(color(d.data.name))
                //     return color(d.data.name);
                // })
                .attr("fill",function(d,i) {
                  var colorindex = data.children.findIndex(function(item, i){
                    if(type==="env"){
                      return parseInt(item.envid) === parseInt(d.data.parent_index)
                    }
                    else if(type==="datasource"){
                      return parseInt(item.integration_id) === parseInt(d.data.integration_id)
                    }
                    else if(type==="dataset"){
                      return parseInt(item.data_set_id) === parseInt(d.data.data_set_id)
                    }
                    else if(type==="attribute"){
                      return parseInt(item.meta_data_id) === parseInt(d.data.meta_data_id)
                    }
                    return 0; 
                  });
                if(colorindex >= color.length){  
                  colorindex = i%color.length;
                }
                  return color[colorindex];
                })
                .attr("fill-opacity", d => arcVisible(d.current) ? (d.children ? 1 : 0.5) : 0)
                .attr("d", d => arc(d.current))
                .on('mouseover', tipinner.show)
                .on('mouseout', tipinner.hide)    

        path.filter(d => d.children)
                .style("cursor", "pointer")
                .on("click", clicked)
                // .on('mouseover', function(d) {
                //   console.log(d);
                // })
                .on('mouseover', tip.show)
                .on('mouseout', tip.hide)

        // path.append("title")
        //         .text(d => `${d.ancestors().map(d => d.data.name).reverse().join("/")}\n${format(d.value)}`);

        const label = g.append("g")
                .attr("pointer-events", "none")
                .attr("text-anchor", "middle")
                .style("user-select", "none")
                
                .selectAll("text")
                .data(root.descendants().slice(1))
                .join("text")
                .attr("dy", "0.35em")
                .attr("fill-opacity", d => +labelVisible(d.current))
                .attr("transform", d => labelTransform(d.current))
                // .style("text-shadow", d => +labelVisible(d.current) === 0 ? "" :"0 1px 0 #fff, 1px 0 0 #fff, -1px 0 0 #fff, 0 -1px 0 #fff")
                // .text(d => label_cutstring(d.data.name,10) +"("+Math.round(d.data.percentage)+")");
                .text(function(d){
                  if(d.depth===1){
                    return label_cutstring(d.data.name,10) +"("+Math.round(d.data.percentage)+")"
                  }else {
                    return label_cutstring(d.data.name,10) +"("+Math.round(d.data.count)+")"
                  }
                });

        const parent = g.append("circle")
                .datum(root)
                .attr("r", radius)
                .attr("fill", "none")
                .attr("pointer-events", "all")
                .on("click", clicked)
        
        let selectedId = 'selecteditem_'+this.props.chartid;

        function clicked(p,i) {
             let icon = "";
             if(type === "env"){
              icon =environment_icon;
             }
             if(type === "datasource"){
              icon =datasource_icon;
             }
             if(type === "dataset"){
              icon =dataset_icon;
             }
            if(p.data.name!==""){
             $("#"+selectedId).addClass(type)
            //  $("#"+selectedId).addClass(color)
            $("#"+selectedId).attr("fill",color[i])

             
             $("#"+selectedId).html(icon+"&nbsp;"+p.data.name+" ("+p.data.percentage+")");
            }else {
              $("#"+selectedId).attr('class', '');
              $("#"+selectedId).html("");
            }
            parent.datum(p.parent || root);
            root.each(d => d.target = {
                    x0: Math.max(0, Math.min(1, (d.x0 - p.x0) / (p.x1 - p.x0))) * 2 * Math.PI,
                    x1: Math.max(0, Math.min(1, (d.x1 - p.x0) / (p.x1 - p.x0))) * 2 * Math.PI,
                    y0: Math.max(0, d.y0 - p.depth),
                    y1: Math.max(0, d.y1 - p.depth)
                });

            const t = g.transition().duration(750);

            // Transition the data on all arcs, even the ones that aren’t visible,
            // so that if this transition is interrupted, entering arcs will start
            // the next transition from the desired position.
            path.transition(t)
                    .tween("data", d => {
                        const i = d3.interpolate(d.current, d.target);
                        return t => d.current = i(t);
                    })
                    .filter(function (d) {
                        return +this.getAttribute("fill-opacity") || arcVisible(d.target);
                    })
                    .attr("fill-opacity", d => arcVisible(d.target) ? (d.children ? 0.6 : 0.4) : 0)
                   // .attr("class", d => +labelVisible(d.current) === 0 ? "" :"dq-report-pie-label")
                    .attrTween("d", d => () => arc(d.current))

            label.filter(function (d) {
                return +this.getAttribute("fill-opacity") || labelVisible(d.target);
            }).transition(t)
                    .attr("fill-opacity", d => +labelVisible(d.target))
                    .style("text-shadow", "none")
                    .attrTween("transform", d => () => labelTransform(d.current));
        }

        function arcVisible(d) {
            return d.y1 <= 3 && d.y0 >= 1 && d.x1 > d.x0;
        }

        function labelVisible(d) {
            return d.y1 <= 3 && d.y0 >= 1 && (d.y1 - d.y0) * (d.x1 - d.x0) > 0.03;
        }

        function labelTransform(d) {
            const x = (d.x0 + d.x1) / 2 * 180 / Math.PI;
            const y = (d.y0 + d.y1) / 2 * radius;
            return `rotate(${x - 90}) translate(${y},0) rotate(${x < 180 ? 0 : 180})`;
        }
}

newIssueChart() {
  $("#"+this.props.chartid).html("");
  let yBegin;
  let innerColumnsList = {};
  let innerColumnsListData = [];
  let obj = this.props.chartdata.data_issue_grouped_bar_chart;
  if(obj.length===0){
    $("#widget1").hide()
  }else {
    $("#widget1").show()
  }
  let totalbar = 0;
  for(let loop=0;loop<obj.length;loop++){
      let newobj = {};
      newobj.MONTH_YEAR = getDateFormat(obj[loop]["month"]);
      let datacheck = 0;
      for (var key in obj[loop]["issues"]){
        for (let key1 in obj[loop]["issues"][key]){
          if(key1!=="env_id"){
            let value = obj[loop]["issues"][key][key1];
               if(value > 0 ){
                datacheck = 1;
               }
               newobj[getmappingvalue("environments",key,this.props.chartdata)+'_'+key1] = value;
        } 
        }   
        if(datacheck === 1){
            innerColumnsList[key+"##"+getmappingvalue("environments",key,this.props.chartdata)]   = [getmappingvalue("environments",key,this.props.chartdata)+"name",getmappingvalue("environments",key,this.props.chartdata)+"_New_issue",getmappingvalue("environments",key,this.props.chartdata)+"_Old_issue",getmappingvalue("integrations",key,this.props.chartdata)+"_Solved_issue"]
            totalbar++;
          }
        }
      innerColumnsListData.push(newobj)
  }
  let data = innerColumnsListData;
  let innerColumns  = innerColumnsList;
  var margin = {top: 20, right: 200, bottom: 75, left: 150},
        width = 960 - margin.left - margin.right,
        height = totalbar*40 - margin.top - margin.bottom;
     
        if(height < 100){
          height = 100;
        }
      
  
    var x0 = d3.scaleBand().range([0, height]).paddingInner(0.10);
    var x1 = d3.scaleBand().padding(0.09);
    var y = d3.scaleLinear()
        .range([0, width]);
    var xAxis = d3.axisLeft()
        .scale(x0);
  
    var yAxis = d3.axisBottom()
        .scale(y)
        .tickSizeInner(-height)
        .tickSizeOuter(0)
        .tickPadding(10)
        .tickFormat(d3.format(".2s"));
     
        var color = d3.scaleOrdinal().range(
          ["#F68B96","#6A91BE","#6FC4DF"]);
        var svg = d3.select("#"+this.props.chartid).append("svg")
         .attr("viewBox", [0, 0, width + margin.left + margin.right, height + margin.top + margin.bottom])
         .attr("font-family", "Poppins")
         .style("width", "100%")
         .attr("width", width + margin.left + margin.right)
         .attr("height", height + margin.top + margin.bottom)
         .append("g")
         .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
  var columnHeaders = d3.keys(data[0]).filter(function(key) { return key !== "MONTH_YEAR"; });
      color.domain(d3.keys(data[0]).filter(function(key) { return key !== "MONTH_YEAR"; }));
      data.forEach(function(d) {
        let env_id;
        let totalissue =0;
        for (var key in d) {
          if (d.hasOwnProperty(key)) {
            if(key.includes("New_issue") || key.includes("Solved_issue") || key.includes("Old_issue") ){
      }
     }
  }

        let yColumn = [];
        let xColumn = [];
        let index = 0;
        // let envid;
        d.columnDetails = columnHeaders.map(function(name) {
          for (let ic in innerColumns) {
            if($.inArray(name, innerColumns[ic]) >= 0){
              if (!yColumn[ic]){
                yColumn[ic] = 0;
                // envid = innerColumns;
                index = 0;
              }
              yBegin = yColumn[ic];
              yColumn[ic] += +d[name];
              xColumn[ic] += +d[name];
              // let yend = d[name] + yBegin;
              // yend = yend === 0 ? 50 : yend;  
              return {name: name, column: ic, yBegin: yBegin, yEnd: +d[name] + yBegin,index:index++,totalissue:totalissue,month:d.MONTH_YEAR,env_id:env_id};
            }
          }
          return true;
        });
        d.total = d3.max(d.columnDetails, function(d) { 
          return d.yEnd; 
        });
      });
    
      x0.domain(data.map(function(d) { return d.MONTH_YEAR; }));
      x1.domain(d3.keys(innerColumns)).range([0, x0.bandwidth()]);
      y.domain([0, d3.max(data, function(d) { 
        return d.total; 
      })]);
  
      svg.append("g")
          .attr("class", "x axis")
          .attr("transform", "translate(0,0)")
          .call(xAxis);
     
      svg.append("g")
          .attr("class", "y axis")
          // .attr("class", function(d,i) { console.log(d);alert(i); return "y axis";})
          .attr("transform", "translate(0,"+height+")")
          .call(yAxis)
        .append("text")
          .attr("transform", "rotate(-90)")
          .attr("y", 0)
          .attr("x", 0)
          .attr("dx", ".7em")
          .style("text-anchor", "end");

          let chatdatatooltip = this.props.chartdata;

          let tip = d3.tip()
  .attr('class', 'd3-tip')
  .direction('e')
  .offset([0,5])
  .html(function(d,i) {
      return getToolTipContent(d,i,chatdatatooltip);
  });
  svg.call(tip);

      var project_stackedbar = svg.selectAll(".project_stackedbar")
          .data(data)
        .enter().append("g")
        .attr("transform", function(d) { return "translate(0," + x0(d.MONTH_YEAR) +")"; });
  
      project_stackedbar.selectAll("rect")
          .data(function(d) { return d.columnDetails; })
          .enter().append("g").attr("class", "groupclass")
          // .attr('stroke', '#E1E1E1')
          // .attr('stroke-width', '1') 
          .append("rect")
          //.attr("height", x1.bandwidth())
          .attr("height", '20px')
          .attr("class", "groupinnerclass ")
          .attr("y", function(d) { 
            return x1(d.column);
          })
          .attr("x", function(d) {
              return y(d.yBegin)+1;
            // return y(d.yEnd) - y(d.yBegin); 
          })
          .attr("width", function(d) { 
            return   y(d.yEnd) - y(d.yBegin); 
          })
          .style("fill", function(d) {
               return color(d.index);
          })
          .attr('stroke', '#fff')
          .attr("stroke-width", function(d,i) {
            if(i%3 === 0){
              return 0;
            }else {
              return 1;
            }
          })
          .on('mouseover', tip.show)
          .on('mouseout', tip.hide)
  
        svg.selectAll(".groupclass")
        .insert("path","rect")
       .attr("stroke", "grey")
       .attr("stroke-width", "1")
       .attr("stroke-dasharray", "5,2")
       .attr("stroke-opacity", "0.2")
       .attr("d", function(d) { 
        return "M5 "+(x1(d.column)+10)+" l"+(width+5)+" 0";
      })
  
      svg.selectAll(".groupclass")
      .append("text")
      .attr("class", "dq-report-gbar-right-label")
      .attr("text-anchor", "start")
      .attr("height", x1.bandwidth())
     .attr("y", function(d) {
       return x1(d.column)+15; })
     .attr("x", width+14)
     .attr("fill","currentColor")
     .text(function(d){
       if(d.index===0){
         return d.column.split("##")[1];
       }
     });
  
  
    // text label for the x axis
    svg.append("text")             
    .attr("transform",
          "translate(" + (width/2) + " ," + 
                         (height + margin.top + 50) + ")")
    .style("text-anchor", "middle")
    .attr("class", "dq-report-graph-title")
    .text("Number of Data Quality Issues - by Environment");
  
  // text label for the y axis
  svg.append("text")
    .attr("transform", "rotate(-90)")
    .attr("y", 0 - margin.left)
    .attr("x",0 - (height / 2))
    .attr("dy", "1em")
    .attr("class", "dq-report-graph-title")
    .style("text-anchor", "middle")
    .text("Month");      
}

newIssueChart_() {
$("#"+this.props.chartid).html("");
let yBegin;
let innerColumnsList = {};
let innerColumnsListData = [];
let obj = this.props.chartdata.data_issue_grouped_bar_chart;
if(obj.length===0){
  $("#widget1").hide()
}else {
  $("#widget1").show()
}
let totalbar = 0;
for(let loop=0;loop<obj.length;loop++){
    let newobj = {};
    newobj.MONTH_YEAR = getDateFormat(obj[loop]["month"]);
    let datacheck = 0;
    for (var key in obj[loop]["issues"]){
      for (let key1 in obj[loop]["issues"][key]){
          let value = obj[loop]["issues"][key][key1];
             if(value > 0 ){
              datacheck = 1;
             }
             newobj[getmappingvalue("environments",key,this.props.chartdata)+'_'+key1] = value;
            }     
        if(datacheck === 1){
          innerColumnsList[getmappingvalue("environments",key,this.props.chartdata)]   = [getmappingvalue("environments",key,this.props.chartdata)+"name",getmappingvalue("environments",key,this.props.chartdata)+"_New_issue",getmappingvalue("environments",key,this.props.chartdata)+"_Old_issue",getmappingvalue("environments",key,this.props.chartdata)+"_Solved_issue"]
          totalbar++;
        }
      }
    innerColumnsListData.push(newobj)
}
let data = innerColumnsListData;
let innerColumns  = innerColumnsList;
var margin = {top: 20, right: 200, bottom: 75, left: 150},
      width = 960 - margin.left - margin.right,
      height = totalbar*40 - margin.top - margin.bottom;
   
      if(height < 100){
        height = 100;
      }
    

  var x0 = d3.scaleBand().range([0, height]).paddingInner(0.10);
  var x1 = d3.scaleBand().padding(0.09);
  var y = d3.scaleLinear()
      .range([0, width]);
  var xAxis = d3.axisLeft()
      .scale(x0);

  var yAxis = d3.axisBottom()
      .scale(y)
      .tickSizeInner(-height)
      .tickSizeOuter(0)
      .tickPadding(10)
      .tickFormat(d3.format(".2s"));
   
  // var color = d3.scaleOrdinal().range(
  //     ["#FB9C24","#36778D","#39AED4"]);

  var color = d3.scaleOrdinal().range(
    ["#F68B96","#6A91BE","#6FC4DF"]);
   
  var svg = d3.select("#"+this.props.chartid).append("svg")
       .attr("viewBox", [0, 0, width + margin.left + margin.right, height + margin.top + margin.bottom])
       .attr("font-family", "Poppins")
       .style("width", "100%")
       .attr("width", width + margin.left + margin.right)
       .attr("height", height + margin.top + margin.bottom)
       .append("g")
       .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
  
var columnHeaders = d3.keys(data[0]).filter(function(key) { return key !== "MONTH_YEAR"; });
    color.domain(d3.keys(data[0]).filter(function(key) { return key !== "MONTH_YEAR"; }));
    // console.log("DATA");
    // console.log(data);
    data.forEach(function(d) {
      let totalissue =0;
      for (var key in d) {
       // console.log(d);
        if (d.hasOwnProperty(key)) {
          if(key.includes("New_issue") || key.includes("Solved_issue") || key.includes("Old_issue") ){
            totalissue += parseInt(d[key])
          }
        }
     }


      let yColumn = [];
      let xColumn = [];
      let index = 0;
      d.columnDetails = columnHeaders.map(function(name) {
        for (let ic in innerColumns) {
          if($.inArray(name, innerColumns[ic]) >= 0){
            if (!yColumn[ic]){
              yColumn[ic] = 0;
              index = 0;
            }
            yBegin = yColumn[ic];
            yColumn[ic] += +d[name];
            xColumn[ic] += +d[name];
            // let yend = d[name] + yBegin;
            // yend = yend === 0 ? 50 : yend;  
            return {name: name, column: ic, yBegin: yBegin, yEnd: +d[name] + yBegin,index:index++,totalissue:totalissue,month:d.MONTH_YEAR};
          }
        }
        return true;
      });
      d.total = d3.max(d.columnDetails, function(d) { 
        return d.yEnd; 
      });
    });
  
    x0.domain(data.map(function(d) { return d.MONTH_YEAR; }));
    x1.domain(d3.keys(innerColumns)).range([0, x0.bandwidth()]);
   
    y.domain([0, d3.max(data, function(d) { 
      return d.total; 
    })]);

    svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0,0)")
        .call(xAxis);
   
    svg.append("g")
        .attr("class", "y axis")
        // .attr("class", function(d,i) { console.log(d);alert(i); return "y axis";})
        .attr("transform", "translate(0,"+height+")")
        .call(yAxis)
      .append("text")
        .attr("transform", "rotate(-90)")
        .attr("y", 0)
        .attr("x", 0)
        .attr("dx", ".7em")
        .style("text-anchor", "end");


        let tip = d3.tip()
.attr('class', 'd3-tip')
.direction('e')
.offset([0,5])
.html(function(d,i) {
    return getToolTipContent(d,i);
});
svg.call(tip);


        
    var project_stackedbar = svg.selectAll(".project_stackedbar")
        .data(data)
      .enter().append("g")
      .attr("transform", function(d) { return "translate(0," + x0(d.MONTH_YEAR) +")"; });

    project_stackedbar.selectAll("rect")
        .data(function(d) { return d.columnDetails; })
        .enter().append("g").attr("class", "groupclass")
        // .attr('stroke', '#E1E1E1')
        // .attr('stroke-width', '1') 
        .append("rect")
        //.attr("height", x1.bandwidth())
        .attr("height", '18px')
        .attr("class", "groupinnerclass ")
        .attr("y", function(d) { 
          return x1(d.column);
        })
        .attr("x", function(d) {
            return y(d.yBegin)+1;
          // return y(d.yEnd) - y(d.yBegin); 
        })
        .attr("width", function(d) { 
          return   y(d.yEnd) - y(d.yBegin); 
        })
        .style("fill", function(d) {
             return color(d.index);
        })
        .attr('stroke', '#fff')
        .attr("stroke-width", function(d,i) {
          if(i%3 === 0){
            return 0;
          }else {
            return 1;
          }
        })
        .on('mouseover', tip.show)
        .on('mouseout', tip.hide)

      svg.selectAll(".groupclass")
      .insert("path","rect")
     .attr("stroke", "grey")
     .attr("stroke-width", "1")
     .attr("stroke-dasharray", "5,2")
     .attr("stroke-opacity", "0.2")
     .attr("d", function(d) { 
      return "M5 "+(x1(d.column)+10)+" l"+(width+5)+" 0";
    })

    svg.selectAll(".groupclass")
    .append("text")
    .attr("class", "dq-report-gbar-right-label")
    .attr("text-anchor", "start")
    .attr("height", x1.bandwidth())
   .attr("y", function(d) {
     return x1(d.column)+15; })
   .attr("x", width+14)
   .attr("fill","currentColor")
   .text(function(d){
     if(d.index===0){
       return d.column;
     }
   });


  // text label for the x axis
  svg.append("text")             
  .attr("transform",
        "translate(" + (width/2) + " ," + 
                       (height + margin.top + 50) + ")")
  .style("text-anchor", "middle")
  .attr("class", "dq-report-graph-title")
  .text("Number of Data Quality Issues - by Environment");


// text label for the y axis
svg.append("text")
  .attr("transform", "rotate(-90)")
  .attr("y", 0 - margin.left)
  .attr("x",0 - (height / 2))
  .attr("dy", "1em")
  .attr("class", "dq-report-graph-title")
  .style("text-anchor", "middle")
  .text("Month");      
}

slopechart(pmId) {
  $("#"+pmId).html("")
  let jsondataformat = this.props.chartdata.integration_slope_chart;
  let pmData  = this.props.chartdata;
  let len = jsondataformat.length
  let dataheader = [];
  let thismonth,prevmonth;

  for (let loop=0;loop<len;loop++){
    let arrstr = {}
    arrstr.Name = getmappingvalue("integrations",jsondataformat[loop]["integration_id"],pmData);
    arrstr.PreviousName = getmappingvalue("integrations",jsondataformat[loop]["integration_id"],pmData);
    arrstr.Before = jsondataformat[loop]["Previous Month"]["rank"]
    arrstr.BeforeCnt = jsondataformat[loop]["Previous Month"]["count"]
    arrstr.PreviousIntergrationId = jsondataformat[loop]["integration_id"];
    let curmonthname;
    curmonthname = jsondataformat[loop]["integration_id"]
    arrstr.ActualAfterCnt = jsondataformat[loop]["This Month"]["count"]
    arrstr.After = jsondataformat[loop]["This Month"]["rank"]
    arrstr.LastNameIntergrationId = jsondataformat[loop]["integration_id"];
    arrstr.LastName = getmappingvalue("integrations",curmonthname,pmData);

    for (let loopinner=0;loopinner<len;loopinner++){
      if(jsondataformat[loopinner]["This Month"]["rank"] === jsondataformat[loop]["Previous Month"]["rank"]){
        curmonthname = jsondataformat[loopinner]["integration_id"]
        arrstr.AfterCnt = jsondataformat[loopinner]["This Month"]["count"]
        arrstr.LastName = getmappingvalue("integrations",curmonthname,pmData);
      }
    }

    dataheader.push(arrstr);
    if(jsondataformat[loop]["This Month"]["month"]!==""){
      thismonth = jsondataformat[loop]["This Month"]["month"];
    }
    if(jsondataformat[loop]["Previous Month"]["month"]!==""){
      prevmonth = jsondataformat[loop]["Previous Month"]["month"];
    }
  }
let data = dataheader;
// Label each point as increasing/decreasing above thresholds
// or just little to no change
var arrayLength = data.length;
for (let i = 0; i < arrayLength; i++) {
    let change = data[i]['BeforeCnt'] - data[i]['ActualAfterCnt'];
    if (change < 0) {
      data[i]['Change'] = 'positive';
    } else if (change > 0) {
      data[i]['Change'] = 'negative';
    } else {
      data[i]['Change'] = 'neutral';
    }
}
var opts = {
  width: 1010,
  height:(data.length*50)+70,
  margin: {top: 100, right: 10, bottom: 100, left: 10}
};
$("#slopechart").css("height",(data.length*34)+70);
// Calculate area chart takes up out of entire svg
var chartHeight = opts.height - opts.margin.top - opts.margin.bottom;
var chartWidth = opts.width - opts.margin.left - opts.margin.right;

var svg = d3.select('#'+pmId)
  .append('svg')
  .attr("viewBox", [0, 0, chartWidth, chartHeight+10])
          // .attr("font-size", 10)
          .attr("font-family", "'Poppins', sans-serif")
          .attr("width", chartWidth)
          .attr("height", chartHeight)
          .style("width", "100%")
          .style("fill", "#484848")
  

// Create scale for positioning data correctly in chart
// var vertScale = d3.scaleLinear().domain([200, 53]).range([opts.margin.bottom, chartHeight]);

var vertScale = d3.scaleLinear()
.domain(d3.extent(data, d => d.After))  
//  .domain([0, d3.max(data, function(d) { return d.Before })])
.range([chartHeight,opts.margin.bottom]);

// Labels overlap, need to precompute chart height placement
// and adjust to avoid label overlap

// First, calculate the right and left side chart placements
for (var i = 0; i < arrayLength; i++) {
  data[i]['AfterY'] = vertScale(data[i]['After']);
  data[i]['BeforeY'] = vertScale(data[i]['Before']);
}

// Next, use a basic heuristic to pull labels up or down
// If next item is too close to next one, move label up
// If next item is too close and item above has been moved up, keep the same value,
// and move next value down
/*
for (var k = 1; k < (arrayLength - 1); k++) {
  if ((data[k]['BeforeY']-data[k+1]['BeforeY']) < 15) {
    if ((data[k-1]['BeforeY']-data[k]['BeforeY']) < 15) {
      data[k+1]['BeforeY'] = data[k+1]['BeforeY'] - 10;
    } else {
      data[k]['BeforeY'] = data[k]['BeforeY'] + 10;
    }
  }
}
for (var j = 1; j < (arrayLength - 1); j++) {
  if ((data[j]['AfterY']-data[j+1]['AfterY']) < 15) {
    if ((data[j-1]['AfterY']-data[j]['AfterY']) < 15) {
      data[j+1]['AfterY'] = data[j+1]['AfterY'] - 10;
    } else {
      data[j]['AfterY'] = data[j]['AfterY'] + 10;
    }
  } else if ((data[j-1]['AfterY']-data[j]['AfterY']) < 15) {
    data[j]['AfterY'] = data[j]['AfterY'] - 10;
  } 
} */
 
  // This X Axis  Labels		
  svg.append('text')
  .style("font-weight","bold")
    .text(prevmonth+" "+this.props.monthviewyear)
    .attr('x', 150)
    .attr('y', 20)
    .attr('text-anchor', 'middle');
  
  svg.append('text')
  .style("font-weight","bold")
    .text(thismonth+" "+this.props.monthviewyear)
    .attr('x', 730)
    .attr('y', 20)
    .attr('text-anchor', 'middle');

// This X Axis  Labels		
  svg.append('text')
  .style("font-weight","600")
    .text("No. of Issues")
    .attr('x', 46)
    .attr('y', 65)
    .style("fill","#888888")
    .attr('text-anchor', 'middle');

   
  svg.append('text')
    .text("Datasource")
    .style("font-weight","600")
    .attr('x', 270)
    .attr('y', 65)
    .attr('text-anchor', 'end');


  svg.append('text')
    .text("Rank")
    .style("font-weight","600")
    .attr('x', 350)
    .attr('y', 65)
    .attr('text-anchor', 'middle');
    
  svg.append('text')
  .style("font-weight","600")
    .text("Rank")
    .attr('x', 650)
    .attr('y', 65)
    .attr('text-anchor', 'middle');
  
  svg.append('text')
  .style("font-weight","600")
    .text('Datasource')
    .attr('x', 700)
    .attr('y', 65)
    .attr('text-anchor', 'start');

  svg.append('text')
    .text('No. of Issues')
    .attr('x', 940)
    .attr('y', 65)
    .style("font-weight","600")
    .style("fill","#888888")
    // .attr('text-anchor', 'start');
    .attr('text-anchor', 'middle');

    // Create slopegraph labels
    svg.selectAll('text.labels')
    .data(data)
    .enter()
    .append('text')
    .style("fill","#888888")
    .text(function(d) {
      return d.BeforeCnt
    })
    .attr('class', function(d) {
      return 'dq-reports-slope-label ';
    })
    .attr('text-anchor', 'middle')
    .attr('x', 35)
    .attr('y', function(d) { 
      return opts.margin.top + chartHeight - d.BeforeY;
    })
   // .attr('dy', '.15em');

  // Create slopegraph labels
  svg.selectAll('text.labels')
    .data(data)
    .enter()
    .append('text')
    .text(function(d) {
      return d.Name
    })
    .attr('class', function(d) {
      return 'dq-reports-slope-label ';
    })
    .attr('text-anchor', 'end')
    .attr('x', 270)
    .attr('y', function(d) { 
      return opts.margin.top + chartHeight - d.BeforeY;
    })
    // .attr('dy', '.15em');


    // svg.selectAll("text.labels")
    // .data(data)
    // .enter()
    //  .append("path")
    //  .attr("stroke", "grey")
    //  .attr("stroke-width", "1")
    //  .attr("stroke-dasharray", "5,2")
    //  .attr("stroke-opacity", "0.2")
    //  .attr("d", function(d) { 
    //   return "M"+opts.margin.left *.6+" "+(opts.margin.top + chartHeight - d.BeforeY)+" l"+(chartWidth-10)+" 0";
    // })

  
  // Create slopegraph left value labels
  svg.selectAll('text.leftvalues')
    .data(data)
    .enter()
    .append('text')
    .attr('class', function(d) {
      // return d.Change; 
      return 'dq-reports-slope-label'
    })
    .text(function(d,i) {
        for(let loop=0;loop < data.length;loop++){
          if(data[loop]["BeforeCnt"] === Math.round(d.BeforeCnt)){
          //return (data[i]["Before"]);
          return d.Before;
        }
      }
    })
    // .attr('text-anchor', 'end')
    .attr('x', 350)
    .attr('y', function(d) { 
      return opts.margin.top + chartHeight - d.BeforeY;
    })
    .attr('text-anchor', 'middle')
    // .attr('dy', '.35em');
    svg.selectAll('text.leftvalues')
    .data(data)
    .enter()
    .append('text')
    .attr('class', function(d) {
      return 'dq-reports-slope-label'
    })
    .text(function(d,i) {
    //  console.log(d)
      return (Math.round(d.Before));
      /*for(let loop=0;loop < data.length;loop++){
        if(data[loop]["AfterCnt"] === Math.round(d.AfterCnt)){
          return (data[loop]["Before"]);
        }
     }*/
    })
    .attr('x', 650)
    .attr('y', function(d) { 
      return opts.margin.top + chartHeight - d.BeforeY;
    })
    .attr('text-anchor', 'middle')

    // Create slopegraph lines
  svg.selectAll('line.slope-line')
    .data(data)
    .enter()
    .append('line')
    .attr('class', function(d) {
      return 'slope-line  ' + d.Change;
    })
    .attr('x1', 400)
    .attr('x2', 600)
    .attr('y1', function(d) { 
      return opts.margin.top + chartHeight - vertScale(d.Before);
    })
    .attr('y2', function(d) { 
      return opts.margin.top + chartHeight - vertScale(d.After);
    });
  
  // Create slopegraph left circles
  svg.selectAll('line.left-circle')
    .data(data)
    .enter()
    .append('circle')
    .attr('class', function(d) {
      return d.Change;
    })
    .attr('cx', 400)
    .attr('cy', function(d) { 
      return opts.margin.top + chartHeight - vertScale(d.Before);
    })
    .attr('r', 6);
  
  // Create slopegraph right circles
  svg.selectAll('line.right-circle')
    .data(data)
    .enter()
    .append('circle')
    .attr('class', function(d) {
      return d.Change;
    })
    .attr('cx',600)
    .attr('cy', function(d) { 
      return opts.margin.top + chartHeight - vertScale(d.After);
    })
    .attr('r', 6);

    // Create slopegraph labels
  svg.selectAll('text.labels')
    .data(data)
    .enter()
    .append('text')
    .text(function(d) {
      return d.LastName
    })
    .attr('class', function(d) {
      return 'dq-reports-slope-label';
    })
    // .attr('text-anchor', 'end')
    .attr('x', 700)
    .attr('y', function(d) { 
      return opts.margin.top + chartHeight - d.BeforeY;
    })
    // .attr('dy', '.15em');

    svg.selectAll('text.labels')
    .data(data)
    .enter()
    .append('text')
    .style("fill","#888888")
    .text(function(d) {
      return d.AfterCnt
    })
    .attr('class', function(d) {
      return 'dq-reports-slope-label';
    })
    // .attr('text-anchor', 'end')
    .attr('x', 950)
    .attr('y', function(d) { 
      return opts.margin.top + chartHeight - d.BeforeY;
    })
    .attr('text-anchor', 'middle');
    // .attr('dy', '.15em');
}

render() {

      return (
          <>
{(() => {
        switch (this.props.chartid) {
          case 'canvas':
            this.renderTop5DataQualityChart();
            break;
          case 'newissue':
            this.newIssueChart();
            break;
          case 'datasourcenewissue':
            this.newIssueDatasourceChart();
            break;  
          case 'dataqualityissuebyenviromentdonut':
            this.environmentssunbrustchart();
            break;
          case 'dataqualityissuebyenviromentheatmap':
            this.heatmapenvdataqualityissue();
            this.heatmapcolorlegend("dataqualityissuebyenviromentheatmaplegend")
            break;
          case 'slopechart':
            this.slopechart('slopechart');
            break;
          case 'dataqualityissuebydatasetheatmap':
            this.dataqualityissuebydatasetheatmap();
            this.heatmapcolorlegend("dataqualityissuebydatasetheatmaplegend")
            break;
          case 'datasource_quality_issue_donut':
            this.datasourcesunbrustchart();
            break;
          case 'dataset_quality_issue_donut':
            this.datasetsunbrustchart();
            break;
          case 'attribute_quality_issue_donut':
              this.attributesunbrustchart();
            break;  
          case 'packedChart':
            this.packedChart();
            break;
          case 'dataqualityissuebyattributeheatmap':
            this.dataqualityissuebyattributeheatmap();
            this.heatmapcolorlegend("dataqualityissuebyattrheatmaplegend")
            break;
          default:
            return null
        }
      })()}
  </>
   )
  }

}
export default dqReports;